import { ref as U, reactive as Gt, computed as Y, shallowRef as De, onMounted as ot, onBeforeUnmount as rt, defineComponent as ke, openBlock as h, createElementBlock as g, normalizeClass as O, createElementVNode as r, withKeys as de, withModifiers as Q, toDisplayString as L, withDirectives as Bn, vModelText as Pn, createCommentVNode as B, Fragment as ce, renderList as xe, createStaticVNode as ve, normalizeStyle as ye, createTextVNode as St, renderSlot as we, watch as J, toRaw as Ut, nextTick as zn, markRaw as Et, unref as b, createVNode as Ve, mergeProps as At, createSlots as Rn, withCtx as Vt, createBlock as Lt, Transition as On } from "vue";
import * as N from "three";
import { useControls as Nn, SCENE_BG_COLOR as at, CAMERA_NEAR_PLANE as In, CAMERA_FAR_PLANE as Gn, CAMERA_INITIAL_Z_POSITION as Un, createRenderer as Vn, createComposer as Xn, isReducedMotionPreferred as Hn, useCamera as Wn, terminateParserWorker as jn, SCENE_BG_COLOR_DARK as $t, loadFont as Kn, loadDefaultFont as Yn, createThreeObjectsFromDXF as Zn, parseDxfAsync as Jn, parseDxf as qn, resolveThemeColor as Dt, rgbNumberToHex as st, ACI_PALETTE as Xt, getUnitsToMmFactor as nt, measureArea as Qn, measurePerimeter as _n, measureDirectedAngle as ea, toDegrees as ta, groupLayersByPrefix as na, buildPickingIndex as aa, buildEntityIndex as Ft, findEntitiesByLayer as sa, getZoomBox as oa, getZoomBoxForLayer as ra } from "dxf-render";
export * from "dxf-render";
import { createPickingController as la, createHighlightController as ia, createRectangleSelectionController as ca, createMeasurementController as ua, createAreaMeasurementController as da, createAngleMeasurementController as fa, createSnapController as va, formatMeasureValue as ha, formatAreaValue as Bt, formatAngleValue as ma } from "dxf-interaction";
import { buildWorldRect as yr, formatAngleValue as xr, formatAreaValue as kr, formatMeasureValue as br, normaliseScreenRect as wr, resolveSelectionMode as Cr } from "dxf-interaction";
function ga() {
  const e = U(!0), t = U(null);
  let a = null, i = null, n = null, o = null, f = null, v = null;
  const {
    initControls: T,
    getControls: p,
    setTarget: x,
    saveState: M,
    resetCamera: D,
    cleanup: F
  } = Nn(), C = () => {
    try {
      const $ = document.createElement("canvas");
      return !!($.getContext("webgl") || $.getContext("experimental-webgl"));
    } catch {
      return !1;
    }
  }, m = ($) => {
    if (!$) return;
    const k = $;
    k.map instanceof N.Texture && k.map.dispose(), k.lightMap instanceof N.Texture && k.lightMap.dispose(), k.bumpMap instanceof N.Texture && k.bumpMap.dispose(), k.normalMap instanceof N.Texture && k.normalMap.dispose(), k.specularMap instanceof N.Texture && k.specularMap.dispose(), k.envMap instanceof N.Texture && k.envMap.dispose(), k.alphaMap instanceof N.Texture && k.alphaMap.dispose(), k.aoMap instanceof N.Texture && k.aoMap.dispose(), k.displacementMap instanceof N.Texture && k.displacementMap.dispose(), k.emissiveMap instanceof N.Texture && k.emissiveMap.dispose(), k.gradientMap instanceof N.Texture && k.gradientMap.dispose(), k.metalnessMap instanceof N.Texture && k.metalnessMap.dispose(), k.roughnessMap instanceof N.Texture && k.roughnessMap.dispose(), $.dispose();
  }, R = ($) => {
    if ($)
      for ($.traverse((k) => {
        if (k instanceof N.Mesh || k instanceof N.Line || k instanceof N.Points) {
          if (k.geometry) {
            k.geometry.dispose();
            for (const ne of Object.keys(k.geometry.attributes))
              k.geometry.deleteAttribute(ne);
            k.geometry.setIndex(null);
          }
          k.material && (Array.isArray(k.material) ? k.material.forEach((ne) => m(ne)) : m(k.material));
        }
      }); $.children.length > 0; ) {
        const k = $.children[0];
        k && $.remove(k);
      }
  }, z = ($, k = {}) => {
    const { enableControls: ne = !1, aaMode: ae = "msaa" } = k;
    if (t.value = null, !C()) {
      e.value = !1, t.value = "WebGL is not supported in this browser", $.innerHTML = "";
      return;
    }
    a = new N.Scene(), a.background = new N.Color(at);
    const te = $.clientWidth, q = $.clientHeight, re = te / q, I = 100;
    i = new N.OrthographicCamera(
      I * re / -2,
      I * re / 2,
      I / 2,
      I / -2,
      In,
      Gn
    ), i.position.set(0, 0, Un), i.zoom = 1;
    try {
      n = Vn({ aaMode: ae }), n.setSize(te, q);
    } catch (S) {
      const G = S instanceof Error ? S.message : "Unknown error creating renderer";
      e.value = !1, t.value = `WebGL initialization error: ${G}`;
      return;
    }
    const E = Xn({ aaMode: ae, scene: a, camera: i, renderer: n });
    o = E.composer, f = E.taaPass, $.appendChild(n.domElement), ne && T(i, n.domElement);
  }, d = ($) => {
    if ($ && (R($), a && a.remove($)), a)
      for (; a.children.length > 0; ) {
        const k = a.children[0];
        k && (R(k), a.remove(k));
      }
    F(), u(), o && (o.dispose(), o = null), f = null, n && (n.dispose(), n.domElement && n.domElement.parentElement && n.domElement.parentElement.removeChild(n.domElement), n = null), a = null, i = null, t.value = null;
  }, u = () => {
    v !== null && (cancelAnimationFrame(v), v = null);
  }, l = () => {
    if (!(!o || !f)) {
      if (f.accumulateIndex >= 32) {
        v = null;
        return;
      }
      o.render(), v = requestAnimationFrame(l);
    }
  };
  return {
    webGLSupported: e,
    error: t,
    initThreeJS: z,
    cleanup: d,
    disposeObject3D: R,
    renderScene: () => {
      if (!(!n || !a || !i)) {
        if (f && o) {
          u(), f.accumulateIndex = -1, o.render(), Hn() || (v = requestAnimationFrame(l));
          return;
        }
        if (o) {
          o.render();
          return;
        }
        n.render(a, i);
      }
    },
    resizeComposer: ($, k) => {
      o && o.setSize($, k);
    },
    getScene: () => a,
    getCamera: () => i,
    getRenderer: () => n,
    getControls: p,
    setOrbitTarget: x,
    saveOrbitState: M,
    resetOrbitControls: D
  };
}
function pa() {
  const e = U(!1), t = U(0), a = U(100), i = Gt({
    fps: 0,
    drawCalls: 0,
    triangles: 0,
    lines: 0
  }), n = {
    currentDXFGroup: null,
    currentMaterials: null,
    originOffset: new N.Vector3(),
    abortController: null,
    baseZoom: 1,
    frameCount: 0,
    lastFpsTime: 0,
    fpsIdleTimer: null
  }, {
    webGLSupported: o,
    error: f,
    initThreeJS: v,
    cleanup: T,
    disposeObject3D: p,
    renderScene: x,
    resizeComposer: M,
    getScene: D,
    getCamera: F,
    getRenderer: C,
    getControls: m,
    setOrbitTarget: R,
    saveOrbitState: z,
    resetOrbitControls: d
  } = ga(), { fitCameraToBox: u, handleResize: l, resetResizing: y } = Wn(), X = () => {
    const E = F();
    E && n.baseZoom > 0 && (a.value = Math.round(E.zoom / n.baseZoom * 100)), x();
    let S = 0, G = 0, K = 0;
    n.currentDXFGroup && n.currentDXFGroup.traverse((me) => {
      if (!me.visible) return;
      const H = me;
      if (!H.geometry) return;
      S++;
      const P = H.geometry.getAttribute("position");
      if (P)
        if (H.isMesh) {
          const A = H.geometry.index;
          G += A ? A.count / 3 : P.count / 3;
        } else H.isLineSegments && (K += P.count / 2);
    }), i.drawCalls = S, i.triangles = G, i.lines = K, n.frameCount++;
    const le = performance.now(), Z = le - n.lastFpsTime;
    Z >= 500 && (i.fps = Math.round(n.frameCount * 1e3 / Z), n.frameCount = 0, n.lastFpsTime = le), n.fpsIdleTimer && clearTimeout(n.fpsIdleTimer), n.fpsIdleTimer = setTimeout(() => {
      i.fps = 0;
    }, 1e3);
  };
  return {
    isLoading: e,
    displayProgress: t,
    zoomPercent: a,
    debugInfo: i,
    webGLSupported: o,
    error: f,
    initThreeJS: (E, S = {}) => {
      v(E, S);
      const G = m();
      G && G.addEventListener("change", X);
    },
    parseDXF: (E) => {
      try {
        return qn(E);
      } catch (S) {
        const G = S instanceof Error ? S.message : "Unknown parsing error";
        throw new Error(`DXF file parsing error: ${G}`);
      }
    },
    parseDXFAsync: (E) => Jn(E),
    displayDXF: async (E, S, G) => {
      const K = D(), le = F(), Z = C();
      if (!K)
        return;
      K.background = new N.Color(S ? $t : at), n.abortController && n.abortController.abort(), t.value = 0, n.abortController = new AbortController();
      const me = n.abortController.signal;
      n.currentDXFGroup && (p(n.currentDXFGroup), K.remove(n.currentDXFGroup), n.currentDXFGroup = null), Z && Z.renderLists.dispose();
      const H = G ? await Kn(G) : Yn(), P = await Zn(E, {
        signal: me,
        onProgress: (A) => {
          t.value = A;
        },
        darkTheme: S,
        font: H
      });
      if (me.aborted) {
        p(P.group);
        return;
      }
      if (K.add(P.group), n.currentDXFGroup = P.group, n.currentMaterials = P.materials, le) {
        const A = P.originOffset;
        n.originOffset.set(A.x, A.y, 0);
        const oe = E.header?.$EXTMIN, ie = E.header?.$EXTMAX;
        let ge;
        if (oe && ie && oe.x < ie.x && oe.y < ie.y ? ge = new N.Box3(
          new N.Vector3(oe.x - A.x, oe.y - A.y, oe.z ?? 0),
          new N.Vector3(ie.x - A.x, ie.y - A.y, ie.z ?? 0)
        ) : ge = new N.Box3().setFromObject(P.group), A.x === 0 && A.y === 0) {
          const pe = ge.getCenter(new N.Vector3());
          n.originOffset.set(pe.x, pe.y, 0), P.group.position.set(-pe.x, -pe.y, 0), ge.translate(new N.Vector3(-pe.x, -pe.y, 0));
        }
        R(0, 0, 0), u(ge, le), n.baseZoom = le.zoom, a.value = 100, z();
      }
      return X(), P.warnings && console.warn("Warnings during DXF processing:", P.warnings), P.unsupportedEntities;
    },
    handleResize: (E) => {
      l(E, F(), C(), D(), (S, G) => {
        M(S, G), x();
      });
    },
    resetView: () => {
      n.currentDXFGroup && F() && (d(), X());
    },
    zoomToBox: (E) => {
      const S = F();
      if (!S || E.isEmpty()) return;
      const G = E.getCenter(new N.Vector3());
      R(G.x, G.y, 0), u(E, S), z(), X();
    },
    applyLayerVisibility: (E) => {
      n.currentDXFGroup && (n.currentDXFGroup.traverse((S) => {
        const G = S.userData?.layerName;
        G !== void 0 && (S.visible = E.has(G));
      }), X());
    },
    switchTheme: (E) => {
      const S = D();
      !S || !n.currentMaterials || (S.background = new N.Color(E ? $t : at), n.currentMaterials.switchTheme(E), X());
    },
    cleanup: () => {
      jn();
      const E = m();
      E && E.removeEventListener("change", X), T(n.currentDXFGroup), n.currentDXFGroup = null, n.currentMaterials = null, n.originOffset = new N.Vector3(), n.abortController = null, n.fpsIdleTimer && (clearTimeout(n.fpsIdleTimer), n.fpsIdleTimer = null), y();
    },
    getCamera: F,
    getRenderer: C,
    getScene: D,
    getControls: m,
    getOriginOffset: () => n.originOffset,
    render: X
  };
}
const Pt = () => typeof window < "u" && typeof window.localStorage < "u";
function ya(e) {
  const t = U(/* @__PURE__ */ new Map()), a = () => e?.getControlledHidden?.() !== void 0, i = () => {
    if (!Pt()) return /* @__PURE__ */ new Set();
    const d = e?.getStorageKey?.();
    if (!d) return /* @__PURE__ */ new Set();
    try {
      const u = window.localStorage.getItem(d);
      if (!u) return /* @__PURE__ */ new Set();
      const l = JSON.parse(u);
      return Array.isArray(l) ? new Set(l.filter((y) => typeof y == "string")) : /* @__PURE__ */ new Set();
    } catch {
      return /* @__PURE__ */ new Set();
    }
  }, n = () => {
    if (!Pt()) return;
    const d = e?.getStorageKey?.();
    if (!d) return;
    const u = o();
    try {
      window.localStorage.setItem(d, JSON.stringify(u));
    } catch {
    }
  }, o = () => {
    const d = [];
    return t.value.forEach((u) => {
      !u.visible && !u.frozen && d.push(u.name);
    }), d;
  }, f = (d) => {
    t.value.forEach((u) => {
      u.frozen || (u.visible = !d.has(u.name));
    });
  }, v = (d) => {
    f(new Set(d));
  }, T = () => {
    a() ? e.onChange?.(o()) : n();
  }, p = (d, u, l) => {
    const y = /* @__PURE__ */ new Map();
    for (const [V, ee] of Object.entries(d)) {
      const $ = ee.colorIndex, k = $ === 7 || $ === 255, ne = $ >= 250 && $ <= 251, ae = k ? "\0ACI7" : ne ? "\0ACI" + $ : void 0;
      let te = "#FFFFFF";
      $ >= 1 && $ <= 255 && (te = ae ? Dt(ae, l) : st(Xt[$])), y.set(V, {
        name: V,
        visible: ee.visible && !ee.frozen,
        frozen: ee.frozen,
        locked: ee.locked ?? !1,
        color: te,
        entityCount: u[V] || 0,
        isAci7: k || ne,
        themeSentinel: ae
      });
    }
    const X = l ? "#ffffff" : "#000000";
    for (const [V, ee] of Object.entries(u))
      y.has(V) || y.set(V, {
        name: V,
        visible: !0,
        frozen: !1,
        locked: !1,
        color: X,
        entityCount: ee,
        isAci7: !0
      });
    t.value = y;
    const _ = e?.getControlledHidden?.();
    if (_ !== void 0)
      f(new Set(_));
    else {
      const V = i();
      V.size > 0 && y.forEach((ee) => {
        !ee.frozen && V.has(ee.name) && (ee.visible = !1);
      });
    }
  }, x = (d) => {
    const u = t.value.get(d);
    u && !u.frozen && (u.visible = !u.visible, T());
  }, M = () => {
    t.value.forEach((d) => {
      d.frozen || (d.visible = !0);
    }), T();
  }, D = () => {
    t.value.forEach((d) => {
      d.visible = !1;
    }), T();
  }, F = Y(() => {
    const d = /* @__PURE__ */ new Set();
    return t.value.forEach((u) => {
      u.visible && d.add(u.name);
    }), d;
  }), C = Y(() => o()), m = Y(() => Array.from(t.value.values()));
  return {
    layers: t,
    layerList: m,
    visibleLayerNames: F,
    hiddenLayerNames: C,
    initLayers: p,
    toggleLayerVisibility: x,
    showAllLayers: M,
    hideAllLayers: D,
    setHiddenLayers: v,
    updateLayerThemeColors: (d) => {
      for (const u of t.value.values())
        u.themeSentinel ? u.color = Dt(u.themeSentinel, d) : u.isAci7 && (u.color = d ? "#ffffff" : "#000000");
    },
    clearLayers: () => {
      t.value = /* @__PURE__ */ new Map();
    }
  };
}
function xa() {
  const e = U(null);
  return { errorMessage: e, setError: (i, n) => {
    const o = i instanceof Error ? i.message : n;
    return e.value = o, o;
  }, clearError: () => {
    e.value = null;
  } };
}
function ka() {
  const e = De(null), t = la();
  return {
    hovered: e,
    ...t,
    attach: (o, f, v) => t.attach(o, f, {
      onClick: v.onClick,
      onHover: (T) => {
        e.value = T, v.onHover?.(T);
      }
    }),
    installPickingData: (o, f, v) => {
      t.installPickingData(o, f, v), e.value = null;
    },
    removePickingData: (o) => {
      t.removePickingData(o), e.value = null;
    }
  };
}
function ba() {
  return ia();
}
function wa() {
  const e = De(null), t = U(!1), a = ca((i) => {
    e.value = i, t.value = i !== null;
  });
  return {
    isDragging: t,
    screenRect: e,
    ...a
  };
}
const Ie = 0.05, zt = 1.2;
function Ca(e) {
  let t = null, a = !0;
  const i = (p) => {
    if (!a) return;
    const x = p.target;
    if (x && (x.tagName === "INPUT" || x.tagName === "TEXTAREA" || x.isContentEditable)) return;
    const M = e.getCamera(), D = e.getControls();
    if (!(!M || !D)) {
      switch (p.key) {
        case "ArrowLeft":
          n(M, D, -Ie, 0);
          break;
        case "ArrowRight":
          n(M, D, Ie, 0);
          break;
        case "ArrowUp":
          n(M, D, 0, Ie);
          break;
        case "ArrowDown":
          n(M, D, 0, -Ie);
          break;
        case "+":
        case "=":
          o(M, D, zt);
          break;
        case "-":
        case "_":
          o(M, D, 1 / zt);
          break;
        case "0":
          e.resetView();
          return;
        default:
          return;
      }
      p.preventDefault(), e.render();
    }
  }, n = (p, x, M, D) => {
    const F = (p.right - p.left) / p.zoom, C = (p.top - p.bottom) / p.zoom, m = F * M, R = C * D;
    p.position.x += m, p.position.y += R, x.target.x += m, x.target.y += R, x.update();
  }, o = (p, x, M) => {
    const D = p.zoom * M, F = x.minZoom ?? 1e-5, C = x.maxZoom ?? 1e3;
    p.zoom = Math.min(C, Math.max(F, D)), p.updateProjectionMatrix(), x.update();
  }, f = (p) => {
    v(), t = p, t.tabIndex < 0 && (t.tabIndex = 0), t.addEventListener("keydown", i);
  }, v = () => {
    t && (t.removeEventListener("keydown", i), t = null);
  };
  return { attach: f, detach: v, setEnabled: (p) => {
    a = p;
  } };
}
function Ma() {
  const e = De({ points: [], hoverWorld: null }), t = U(!1), a = ua((n) => {
    e.value = n;
  }), i = (n) => {
    t.value = n, a.setEnabled(n);
  };
  return {
    state: e,
    isActive: t,
    attach: a.attach,
    detach: a.detach,
    setEnabled: i,
    setUnitsScale: a.setUnitsScale,
    setColor: a.setColor,
    clear: a.clear,
    dispose: a.dispose
  };
}
const Ta = () => ({
  points: [],
  hoverWorld: null,
  closed: !1,
  originSnap: !1
});
function Sa() {
  const e = De(Ta()), t = U(!1), a = da((n) => {
    e.value = n;
  }), i = (n) => {
    t.value = n, a.setEnabled(n);
  };
  return {
    state: e,
    isActive: t,
    attach: a.attach,
    detach: a.detach,
    setEnabled: i,
    setUnits: a.setUnits,
    setColor: a.setColor,
    clear: a.clear,
    dispose: a.dispose
  };
}
const Ea = () => ({
  points: [],
  hoverWorld: null,
  closed: !1
});
function Aa() {
  const e = De(Ea()), t = U(!1), a = fa((n) => {
    e.value = n;
  }), i = (n) => {
    t.value = n, a.setEnabled(n);
  };
  return {
    state: e,
    isActive: t,
    attach: a.attach,
    detach: a.detach,
    setEnabled: i,
    setUnits: a.setUnits,
    setColor: a.setColor,
    clear: a.clear,
    dispose: a.dispose
  };
}
function La() {
  const e = U(null), t = va((a) => {
    e.value = a;
  });
  return {
    current: e,
    ...t
  };
}
function $a(e) {
  const t = Y(() => {
    if (e.rulerUnits() === "dxf-units") return 1;
    const f = e.activeDxf.value?.header?.$INSUNITS ?? 0, v = f === 0 ? 1 : nt(f) || 1;
    return e.rulerUnits() === "inch" ? v / 25.4 : v;
  }), a = Y(() => {
    const f = e.rulerUnits();
    return f === "mm" ? "mm" : f === "inch" ? "in" : "—";
  }), i = Y(
    () => e.measureUnits() ?? e.rulerUnits()
  ), n = Y(() => {
    const f = i.value;
    if (f === "dxf-units") return 1;
    const v = e.activeDxf.value?.header?.$INSUNITS ?? 0, T = v === 0 ? 1 : nt(v) || 1;
    return f === "inch" ? T / 25.4 : T;
  }), o = Y(() => {
    const f = e.activeDxf.value?.header?.$INSUNITS ?? 0, v = f === 0 ? 1 : nt(f) || 1;
    let T = e.measureAreaUnits() ?? "auto";
    T === "auto" && (T = e.rulerUnits() === "mm" ? "mm²" : e.rulerUnits() === "inch" ? "in²" : "dxf");
    let p, x, M;
    switch (T) {
      case "mm²":
        p = v, x = "mm²", M = "mm";
        break;
      case "m²":
        p = v / 1e3, x = "m²", M = "m";
        break;
      case "in²":
        p = v / 25.4, x = "in²", M = "in";
        break;
      case "ft²":
        p = v / 304.8, x = "ft²", M = "ft";
        break;
      default:
        p = 1, x = "", M = "";
        break;
    }
    return { areaScale: p * p, perimeterScale: p, areaLabel: x, lengthLabel: M };
  });
  return {
    rulerUnitsScale: t,
    rulerUnitsLabel: a,
    currentMeasureUnits: i,
    measureUnitsScale: n,
    areaUnitScales: o
  };
}
function Da(e) {
  const t = U(0), a = () => {
    t.value++;
  }, i = Y(() => {
    t.value;
    const f = e.measureState.value;
    if (f.points.length === 0) return null;
    const v = f.points[0], T = f.points[1] ?? f.hoverWorld;
    if (!T) return null;
    const p = e.getCamera(), x = e.getContainer();
    if (!p || !x) return null;
    const M = e.getOriginOffset(), D = new N.Vector3(
      (v.x + T.x) / 2 - M.x,
      (v.y + T.y) / 2 - M.y,
      0
    );
    D.project(p);
    const F = x.getBoundingClientRect(), C = (D.x + 1) * 0.5 * F.width, m = (-D.y + 1) * 0.5 * F.height, R = T.x - v.x, z = T.y - v.y, u = Math.sqrt(R * R + z * z) * e.measureUnitsScale.value;
    return {
      left: C,
      top: m,
      text: ha(u, e.currentMeasureUnits.value)
    };
  }), n = Y(() => {
    t.value;
    const f = e.areaState.value, v = f.points;
    if (v.length < 2 && !f.closed) return null;
    const T = f.closed ? v : f.hoverWorld ? [...v, f.hoverWorld] : v;
    if (T.length < 2) return null;
    const p = e.getCamera(), x = e.getContainer();
    if (!p || !x) return null;
    const M = e.getOriginOffset();
    let D = 0, F = 0;
    for (const X of T)
      D += X.x, F += X.y;
    D /= T.length, F /= T.length;
    const C = new N.Vector3(D - M.x, F - M.y, 0);
    C.project(p);
    const m = x.getBoundingClientRect(), R = (C.x + 1) * 0.5 * m.width, z = (-C.y + 1) * 0.5 * m.height, d = e.areaUnitScales.value, u = v.length >= 3, l = Qn(T), y = _n(T);
    return {
      left: R,
      top: z,
      areaText: u ? Bt(l * d.areaScale, d.areaLabel) : "—",
      perimeterText: Bt(y * d.perimeterScale, d.lengthLabel)
    };
  }), o = Y(() => {
    t.value;
    const f = e.angleState.value, v = f.points, T = v[0];
    if (!T) return null;
    let p = null, x = null;
    if (f.closed && v.length >= 3 ? (p = v[1], x = v[2]) : v.length === 2 && (p = v[1], x = f.hoverWorld), !p || !x) return null;
    const M = e.getCamera(), D = e.getContainer();
    if (!M || !D) return null;
    const F = e.getOriginOffset(), C = ea(T, p, x), R = Math.atan2(p.y - T.y, p.x - T.x) + C / 2, z = new N.Vector3(T.x - F.x, T.y - F.y, 0);
    z.project(M);
    const d = D.getBoundingClientRect(), u = (z.x + 1) * 0.5 * d.width, l = (-z.y + 1) * 0.5 * d.height, y = 44, X = u + Math.cos(R) * y, _ = l - Math.sin(R) * y;
    return {
      left: X,
      top: _,
      text: ma(ta(C), e.measureAngleUnits())
    };
  });
  return { cameraTick: t, bumpCameraTick: a, measureLabel: i, areaLabel: n, angleLabel: o };
}
function Fa(e) {
  const t = U(0), a = U(0), i = U(!1), n = (v) => {
    if (!e.isTracking()) return;
    const T = e.getContainer(), p = e.getCamera();
    if (!T || !p) return;
    const x = T.getBoundingClientRect(), M = (v.clientX - x.left) / x.width * 2 - 1, D = -((v.clientY - x.top) / x.height) * 2 + 1, F = new N.Vector3(M, D, 0).unproject(p), C = e.getOriginOffset();
    t.value = F.x + C.x, a.value = F.y + C.y, i.value = !0;
  }, o = () => {
    i.value = !1;
  }, f = Y(() => ({ x: t.value, y: a.value }));
  return { cursorX: t, cursorY: a, isCursorVisible: i, cursorWorld: f, handleMouseMove: n, handleMouseLeave: o };
}
function Ba(e) {
  const t = U(!1);
  let a = null;
  const i = (p) => {
    e.allowDrop() && (a && (clearTimeout(a), a = null), t.value = !0, p.dataTransfer && (p.dataTransfer.dropEffect = "copy"));
  }, n = () => {
    e.allowDrop() && (a = setTimeout(() => {
      t.value = !1;
    }, 50));
  }, o = async (p) => {
    if (!e.allowDrop()) return;
    t.value = !1;
    const x = p.dataTransfer?.files[0];
    if (!x) return;
    e.onFileDropped(x.name);
    const M = await x.text();
    e.loadText(M);
  }, f = (p) => {
    const x = new Uint8Array(p);
    return x.length >= 2 && x[0] === 255 && x[1] === 254 ? new TextDecoder("utf-16le").decode(p) : x.length >= 2 && x[0] === 254 && x[1] === 255 ? new TextDecoder("utf-16be").decode(p) : new TextDecoder("utf-8").decode(p);
  }, v = async (p) => {
    await e.loadText(f(p));
  };
  return {
    isDragOver: t,
    handleDragOver: i,
    handleDragLeave: n,
    handleDrop: o,
    decodeBuffer: f,
    loadDXFFromBuffer: v,
    loadDXFFromBlob: async (p) => {
      const x = await p.arrayBuffer();
      await v(x);
    }
  };
}
function Pa(e) {
  const t = U(!1), a = async () => {
    const n = e();
    n && (document.fullscreenElement ? await document.exitFullscreen() : await n.requestFullscreen());
  }, i = () => {
    t.value = !!document.fullscreenElement;
  };
  return ot(() => {
    document.addEventListener("fullscreenchange", i);
  }), rt(() => {
    document.removeEventListener("fullscreenchange", i);
  }), { isFullscreen: t, toggleFullscreen: a };
}
const za = ["aria-expanded", "aria-label"], Ra = { class: "dxfk-layer-panel-title" }, Oa = ["title", "aria-label"], Na = {
  key: 0,
  class: "dxfk-layer-panel-body"
}, Ia = { class: "dxfk-layer-panel-actions" }, Ga = {
  key: 0,
  class: "dxfk-layer-filter-wrapper"
}, Ua = { class: "dxfk-layer-list" }, Va = {
  key: 0,
  class: "dxfk-layer-empty"
}, Xa = ["aria-label"], Ha = ["aria-expanded", "aria-label", "onClick", "onKeydown"], Wa = ["title", "aria-label"], ja = ["title"], Ka = { class: "dxfk-layer-group-count" }, Ya = ["disabled", "aria-pressed", "aria-disabled", "aria-label", "title", "onClick"], Za = {
  key: 0,
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, Ja = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, qa = {
  key: 2,
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, Qa = {
  key: 0,
  class: "dxfk-layer-group-body"
}, _a = ["tabindex", "aria-pressed", "aria-disabled", "aria-label", "onClick", "onKeydown", "onMouseenter", "onMouseleave"], es = {
  key: 0,
  class: "dxfk-layer-icon-frozen",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, ts = {
  key: 1,
  class: "dxfk-layer-icon-eye",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, ns = {
  key: 2,
  class: "dxfk-layer-icon-eye dxfk-layer-icon-eye--off",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, as = {
  key: 3,
  class: "dxfk-layer-icon-lock",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, ss = ["title"], os = { class: "dxfk-layer-count" }, rs = ["tabindex", "aria-pressed", "aria-disabled", "aria-label", "onClick", "onKeydown", "onMouseenter", "onMouseleave"], ls = {
  key: 0,
  class: "dxfk-layer-icon-frozen",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, is = {
  key: 1,
  class: "dxfk-layer-icon-eye",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, cs = {
  key: 2,
  class: "dxfk-layer-icon-eye dxfk-layer-icon-eye--off",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, us = {
  key: 3,
  class: "dxfk-layer-icon-lock",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, ds = ["title"], fs = { class: "dxfk-layer-count" }, vs = ["tabindex", "aria-pressed", "aria-disabled", "aria-label", "onClick", "onKeydown", "onMouseenter", "onMouseleave"], hs = {
  key: 0,
  class: "dxfk-layer-icon-frozen",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, ms = {
  key: 1,
  class: "dxfk-layer-icon-eye",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, gs = {
  key: 2,
  class: "dxfk-layer-icon-eye dxfk-layer-icon-eye--off",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, ps = {
  key: 3,
  class: "dxfk-layer-icon-lock",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, ys = ["title"], xs = { class: "dxfk-layer-count" }, ks = /* @__PURE__ */ ke({
  __name: "LayerPanel",
  props: {
    layers: {},
    darkTheme: { type: Boolean, default: !1 },
    groupLayers: { type: [Boolean, Object], default: !1 }
  },
  emits: ["toggle-layer", "show-all", "hide-all", "layer-hover"],
  setup(e, { emit: t }) {
    const a = e, i = t, n = U(!0), o = U(""), f = Y(() => {
      const d = o.value.trim().toLowerCase();
      return d ? a.layers.filter((u) => u.name.toLowerCase().includes(d)) : a.layers;
    }), v = Y(() => a.groupLayers ? typeof a.groupLayers == "object" ? a.groupLayers : {} : null), T = Y(() => {
      const d = v.value;
      return d ? na(f.value, d) : null;
    }), p = Y(
      () => T.value?.filter((d) => d.prefix !== "") ?? []
    ), x = Y(
      () => T.value?.find((d) => d.prefix === "")?.layers ?? []
    ), M = Gt({});
    function D(d) {
      M[d] = !M[d];
    }
    function F(d) {
      return !M[d];
    }
    function C(d) {
      const u = d.layers.filter((y) => !y.frozen);
      if (u.length === 0) return "all-frozen";
      let l = 0;
      for (const y of u) y.visible && l++;
      return l === 0 ? "all-hidden" : l === u.length ? "all-visible" : "mixed";
    }
    function m(d) {
      let u = 0;
      for (const l of d.layers) l.visible && !l.frozen && u++;
      return u;
    }
    function R(d) {
      let u = 0;
      for (const l of d.layers) u += l.entityCount;
      return u;
    }
    function z(d) {
      const u = C(d);
      if (u === "all-frozen") return;
      const l = u === "all-hidden";
      for (const y of d.layers)
        y.frozen || y.visible !== l && i("toggle-layer", y.name);
    }
    return (d, u) => (h(), g("div", {
      class: O(["dxfk-layer-panel", [
        { "dxfk-layer-panel--collapsed": !n.value, "dxfk-dark": e.darkTheme }
      ]]),
      role: "region",
      "aria-label": "Layer visibility panel"
    }, [
      r("div", {
        class: "dxfk-layer-panel-header",
        role: "button",
        tabindex: "0",
        "aria-expanded": n.value,
        "aria-label": n.value ? "Collapse layer panel" : "Expand layer panel",
        onClick: u[0] || (u[0] = (l) => n.value = !n.value),
        onKeydown: [
          u[1] || (u[1] = de(Q((l) => n.value = !n.value, ["prevent"]), ["enter"])),
          u[2] || (u[2] = de(Q((l) => n.value = !n.value, ["prevent"]), ["space"]))
        ]
      }, [
        r("span", Ra, "Layers (" + L(e.layers.length) + ")", 1),
        r("button", {
          class: "dxfk-layer-panel-collapse",
          title: n.value ? "Collapse" : "Expand",
          "aria-label": n.value ? "Collapse" : "Expand",
          tabindex: "-1"
        }, L(n.value ? "−" : "+"), 9, Oa)
      ], 40, za),
      n.value ? (h(), g("div", Na, [
        r("div", Ia, [
          r("button", {
            onClick: u[3] || (u[3] = Q((l) => d.$emit("show-all"), ["stop"])),
            class: "dxfk-layer-panel-action",
            "aria-label": "Show all layers"
          }, "All"),
          r("button", {
            onClick: u[4] || (u[4] = Q((l) => d.$emit("hide-all"), ["stop"])),
            class: "dxfk-layer-panel-action",
            "aria-label": "Hide all layers"
          }, "None")
        ]),
        e.layers.length > 5 ? (h(), g("div", Ga, [
          Bn(r("input", {
            "onUpdate:modelValue": u[5] || (u[5] = (l) => o.value = l),
            type: "text",
            class: "dxfk-layer-filter",
            placeholder: "Filter layers…",
            "aria-label": "Filter layers by name",
            onClick: u[6] || (u[6] = Q(() => {
            }, ["stop"]))
          }, null, 512), [
            [Pn, o.value]
          ]),
          o.value ? (h(), g("button", {
            key: 0,
            class: "dxfk-layer-filter-clear",
            "aria-label": "Clear filter",
            onClick: u[7] || (u[7] = Q((l) => o.value = "", ["stop"]))
          }, "×")) : B("", !0)
        ])) : B("", !0),
        r("div", Ua, [
          f.value.length === 0 ? (h(), g("div", Va, 'No layers match "' + L(o.value) + '"', 1)) : B("", !0),
          T.value ? (h(), g(ce, { key: 1 }, [
            (h(!0), g(ce, null, xe(p.value, (l) => (h(), g("div", {
              key: `g:${l.prefix}`,
              class: O(["dxfk-layer-group", { "dxfk-layer-group--collapsed": !F(l.prefix) }]),
              role: "group",
              "aria-label": `Layer group ${l.prefix}`
            }, [
              r("div", {
                class: "dxfk-layer-group-header",
                role: "button",
                tabindex: "0",
                "aria-expanded": F(l.prefix),
                "aria-label": F(l.prefix) ? `Collapse group ${l.prefix}` : `Expand group ${l.prefix}`,
                onClick: (y) => D(l.prefix),
                onKeydown: [
                  de(Q((y) => D(l.prefix), ["prevent"]), ["enter"]),
                  de(Q((y) => D(l.prefix), ["prevent"]), ["space"])
                ]
              }, [
                r("button", {
                  class: "dxfk-layer-group-collapse",
                  tabindex: "-1",
                  title: F(l.prefix) ? "Collapse" : "Expand",
                  "aria-label": F(l.prefix) ? "Collapse" : "Expand"
                }, L(F(l.prefix) ? "−" : "+"), 9, Wa),
                r("span", {
                  class: "dxfk-layer-group-name",
                  title: l.prefix
                }, L(l.prefix), 9, ja),
                r("span", Ka, L(m(l)) + " / " + L(l.layers.length) + " · " + L(R(l)), 1),
                r("button", {
                  class: O(["dxfk-layer-group-toggle", `dxfk-layer-group-toggle--${C(l)}`]),
                  disabled: C(l) === "all-frozen",
                  "aria-pressed": C(l) !== "all-hidden",
                  "aria-disabled": C(l) === "all-frozen",
                  "aria-label": `Toggle visibility of group ${l.prefix}`,
                  title: C(l) === "all-hidden" ? "Show all in group" : "Hide all in group",
                  onClick: Q((y) => z(l), ["stop"])
                }, [
                  C(l) === "mixed" ? (h(), g("svg", Za, [...u[8] || (u[8] = [
                    r("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1),
                    r("path", {
                      d: "M12 4v16",
                      "stroke-width": "1.5"
                    }, null, -1),
                    r("path", {
                      d: "M12 5a7 7 0 0 1 0 14z",
                      fill: "currentColor",
                      stroke: "none"
                    }, null, -1),
                    r("circle", {
                      cx: "12",
                      cy: "12",
                      r: "3"
                    }, null, -1)
                  ])])) : C(l) === "all-hidden" ? (h(), g("svg", Ja, [...u[9] || (u[9] = [
                    r("path", { d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" }, null, -1),
                    r("line", {
                      x1: "1",
                      y1: "1",
                      x2: "23",
                      y2: "23"
                    }, null, -1)
                  ])])) : (h(), g("svg", qa, [...u[10] || (u[10] = [
                    r("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1),
                    r("circle", {
                      cx: "12",
                      cy: "12",
                      r: "3"
                    }, null, -1)
                  ])]))
                ], 10, Ya)
              ], 40, Ha),
              F(l.prefix) ? (h(), g("div", Qa, [
                (h(!0), g(ce, null, xe(l.layers, (y) => (h(), g("div", {
                  key: y.name,
                  class: O(["dxfk-layer-item dxfk-layer-item--in-group", { "dxfk-layer-item--hidden": !y.visible, "dxfk-layer-item--frozen": y.frozen }]),
                  role: "button",
                  tabindex: y.frozen ? -1 : 0,
                  "aria-pressed": y.visible,
                  "aria-disabled": y.frozen,
                  "aria-label": `Toggle visibility of layer ${y.name}`,
                  onClick: (X) => !y.frozen && d.$emit("toggle-layer", y.name),
                  onKeydown: [
                    de(Q((X) => !y.frozen && d.$emit("toggle-layer", y.name), ["prevent"]), ["enter"]),
                    de(Q((X) => !y.frozen && d.$emit("toggle-layer", y.name), ["prevent"]), ["space"])
                  ],
                  onMouseenter: (X) => !y.frozen && d.$emit("layer-hover", y.name),
                  onMouseleave: (X) => !y.frozen && d.$emit("layer-hover", null)
                }, [
                  y.frozen ? (h(), g("svg", es, [...u[11] || (u[11] = [
                    ve('<line x1="12" y1="2" x2="12" y2="22" data-v-c0c33f7a></line><line x1="2" y1="12" x2="22" y2="12" data-v-c0c33f7a></line><line x1="4.93" y1="4.93" x2="19.07" y2="19.07" data-v-c0c33f7a></line><line x1="19.07" y1="4.93" x2="4.93" y2="19.07" data-v-c0c33f7a></line><line x1="12" y1="2" x2="9" y2="5" data-v-c0c33f7a></line><line x1="12" y1="2" x2="15" y2="5" data-v-c0c33f7a></line><line x1="12" y1="22" x2="9" y2="19" data-v-c0c33f7a></line><line x1="12" y1="22" x2="15" y2="19" data-v-c0c33f7a></line>', 8)
                  ])])) : y.visible ? (h(), g("svg", ts, [...u[12] || (u[12] = [
                    r("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1),
                    r("circle", {
                      cx: "12",
                      cy: "12",
                      r: "3"
                    }, null, -1)
                  ])])) : (h(), g("svg", ns, [...u[13] || (u[13] = [
                    r("path", { d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" }, null, -1),
                    r("line", {
                      x1: "1",
                      y1: "1",
                      x2: "23",
                      y2: "23"
                    }, null, -1)
                  ])])),
                  y.locked && !y.frozen ? (h(), g("svg", as, [...u[14] || (u[14] = [
                    r("rect", {
                      x: "3",
                      y: "11",
                      width: "18",
                      height: "11",
                      rx: "2",
                      ry: "2"
                    }, null, -1),
                    r("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" }, null, -1)
                  ])])) : B("", !0),
                  r("span", {
                    class: "dxfk-layer-swatch",
                    style: ye({ backgroundColor: y.color })
                  }, null, 4),
                  r("span", {
                    class: "dxfk-layer-name",
                    title: y.name
                  }, L(y.name), 9, ss),
                  r("span", os, L(y.entityCount), 1)
                ], 42, _a))), 128))
              ])) : B("", !0)
            ], 10, Xa))), 128)),
            (h(!0), g(ce, null, xe(x.value, (l) => (h(), g("div", {
              key: `u:${l.name}`,
              class: O(["dxfk-layer-item", { "dxfk-layer-item--hidden": !l.visible, "dxfk-layer-item--frozen": l.frozen }]),
              role: "button",
              tabindex: l.frozen ? -1 : 0,
              "aria-pressed": l.visible,
              "aria-disabled": l.frozen,
              "aria-label": `Toggle visibility of layer ${l.name}`,
              onClick: (y) => !l.frozen && d.$emit("toggle-layer", l.name),
              onKeydown: [
                de(Q((y) => !l.frozen && d.$emit("toggle-layer", l.name), ["prevent"]), ["enter"]),
                de(Q((y) => !l.frozen && d.$emit("toggle-layer", l.name), ["prevent"]), ["space"])
              ],
              onMouseenter: (y) => !l.frozen && d.$emit("layer-hover", l.name),
              onMouseleave: (y) => !l.frozen && d.$emit("layer-hover", null)
            }, [
              l.frozen ? (h(), g("svg", ls, [...u[15] || (u[15] = [
                ve('<line x1="12" y1="2" x2="12" y2="22" data-v-c0c33f7a></line><line x1="2" y1="12" x2="22" y2="12" data-v-c0c33f7a></line><line x1="4.93" y1="4.93" x2="19.07" y2="19.07" data-v-c0c33f7a></line><line x1="19.07" y1="4.93" x2="4.93" y2="19.07" data-v-c0c33f7a></line><line x1="12" y1="2" x2="9" y2="5" data-v-c0c33f7a></line><line x1="12" y1="2" x2="15" y2="5" data-v-c0c33f7a></line><line x1="12" y1="22" x2="9" y2="19" data-v-c0c33f7a></line><line x1="12" y1="22" x2="15" y2="19" data-v-c0c33f7a></line>', 8)
              ])])) : l.visible ? (h(), g("svg", is, [...u[16] || (u[16] = [
                r("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1),
                r("circle", {
                  cx: "12",
                  cy: "12",
                  r: "3"
                }, null, -1)
              ])])) : (h(), g("svg", cs, [...u[17] || (u[17] = [
                r("path", { d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" }, null, -1),
                r("line", {
                  x1: "1",
                  y1: "1",
                  x2: "23",
                  y2: "23"
                }, null, -1)
              ])])),
              l.locked && !l.frozen ? (h(), g("svg", us, [...u[18] || (u[18] = [
                r("rect", {
                  x: "3",
                  y: "11",
                  width: "18",
                  height: "11",
                  rx: "2",
                  ry: "2"
                }, null, -1),
                r("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" }, null, -1)
              ])])) : B("", !0),
              r("span", {
                class: "dxfk-layer-swatch",
                style: ye({ backgroundColor: l.color })
              }, null, 4),
              r("span", {
                class: "dxfk-layer-name",
                title: l.name
              }, L(l.name), 9, ds),
              r("span", fs, L(l.entityCount), 1)
            ], 42, rs))), 128))
          ], 64)) : (h(!0), g(ce, { key: 2 }, xe(f.value, (l) => (h(), g("div", {
            key: l.name,
            class: O(["dxfk-layer-item", { "dxfk-layer-item--hidden": !l.visible, "dxfk-layer-item--frozen": l.frozen }]),
            role: "button",
            tabindex: l.frozen ? -1 : 0,
            "aria-pressed": l.visible,
            "aria-disabled": l.frozen,
            "aria-label": `Toggle visibility of layer ${l.name}`,
            onClick: (y) => !l.frozen && d.$emit("toggle-layer", l.name),
            onKeydown: [
              de(Q((y) => !l.frozen && d.$emit("toggle-layer", l.name), ["prevent"]), ["enter"]),
              de(Q((y) => !l.frozen && d.$emit("toggle-layer", l.name), ["prevent"]), ["space"])
            ],
            onMouseenter: (y) => !l.frozen && d.$emit("layer-hover", l.name),
            onMouseleave: (y) => !l.frozen && d.$emit("layer-hover", null)
          }, [
            l.frozen ? (h(), g("svg", hs, [...u[19] || (u[19] = [
              ve('<line x1="12" y1="2" x2="12" y2="22" data-v-c0c33f7a></line><line x1="2" y1="12" x2="22" y2="12" data-v-c0c33f7a></line><line x1="4.93" y1="4.93" x2="19.07" y2="19.07" data-v-c0c33f7a></line><line x1="19.07" y1="4.93" x2="4.93" y2="19.07" data-v-c0c33f7a></line><line x1="12" y1="2" x2="9" y2="5" data-v-c0c33f7a></line><line x1="12" y1="2" x2="15" y2="5" data-v-c0c33f7a></line><line x1="12" y1="22" x2="9" y2="19" data-v-c0c33f7a></line><line x1="12" y1="22" x2="15" y2="19" data-v-c0c33f7a></line>', 8)
            ])])) : l.visible ? (h(), g("svg", ms, [...u[20] || (u[20] = [
              r("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1),
              r("circle", {
                cx: "12",
                cy: "12",
                r: "3"
              }, null, -1)
            ])])) : (h(), g("svg", gs, [...u[21] || (u[21] = [
              r("path", { d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" }, null, -1),
              r("line", {
                x1: "1",
                y1: "1",
                x2: "23",
                y2: "23"
              }, null, -1)
            ])])),
            l.locked && !l.frozen ? (h(), g("svg", ps, [...u[22] || (u[22] = [
              r("rect", {
                x: "3",
                y: "11",
                width: "18",
                height: "11",
                rx: "2",
                ry: "2"
              }, null, -1),
              r("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" }, null, -1)
            ])])) : B("", !0),
            r("span", {
              class: "dxfk-layer-swatch",
              style: ye({ backgroundColor: l.color })
            }, null, 4),
            r("span", {
              class: "dxfk-layer-name",
              title: l.name
            }, L(l.name), 9, ys),
            r("span", xs, L(l.entityCount), 1)
          ], 42, vs))), 128))
        ])
      ])) : B("", !0)
    ], 2));
  }
}), be = (e, t) => {
  const a = e.__vccOpts || e;
  for (const [i, n] of t)
    a[i] = n;
  return a;
}, bs = /* @__PURE__ */ be(ks, [["__scopeId", "data-v-c0c33f7a"]]), ws = /* @__PURE__ */ new Set([7, 250, 251, 255]), Ge = "#888888", j = (e, t = 2) => e === void 0 || !Number.isFinite(e) ? "—" : Math.abs(e) >= 1e5 || Math.abs(e) > 0 && Math.abs(e) < 1e-3 ? e.toExponential(2) : e.toFixed(t).replace(/\.?0+$/, "") || "0", se = (e) => {
  if (!e) return "—";
  const t = j(e.x), a = j(e.y), i = e.z;
  return i === void 0 || i === 0 ? `(${t}, ${a})` : `(${t}, ${a}, ${j(i)})`;
}, Rt = (e) => {
  if (e === void 0 || !Number.isFinite(e)) return "—";
  const t = e * 180 / Math.PI;
  return `${j(t, 2)}°`;
}, Ee = (e) => e === void 0 || !Number.isFinite(e) ? "—" : `${j(e, 2)}°`, Ht = (e) => e ? "Yes" : "No", Cs = (e) => e === void 0 ? "ByLayer" : e === -3 ? "Standard" : e === -2 ? "ByLayer" : e === -1 ? "ByBlock" : `${(e / 100).toFixed(2)} mm`, Ms = (e, t) => {
  const a = (e.x ?? 0) - (t.x ?? 0), i = (e.y ?? 0) - (t.y ?? 0), n = (e.z ?? 0) - (t.z ?? 0);
  return Math.sqrt(a * a + i * i + n * n);
}, Ts = (e, t) => {
  if (t !== void 0 && Number.isFinite(t)) {
    const a = st(t);
    return { label: `True color ${a.toUpperCase()}`, swatch: a };
  }
  return e === void 0 || e === 256 ? { label: "ByLayer", swatch: Ge } : e === 0 ? { label: "ByBlock", swatch: Ge } : e < 1 || e > 255 ? { label: `ACI ${e}`, swatch: Ge } : ws.has(e) ? { label: `ACI ${e}`, swatch: Ge } : { label: `ACI ${e}`, swatch: st(Xt[e]) };
}, Ss = (e) => {
  const t = [];
  t.push({ label: "Type", value: e.type }), e.handle !== void 0 && t.push({ label: "Handle", value: String(e.handle), mono: !0 }), t.push({ label: "Layer", value: e.layer || "0" });
  const a = Ts(e.colorIndex, e.color);
  return t.push({ label: "Color", value: a.label, swatch: a.swatch }), t.push({ label: "Linetype", value: e.lineType || "ByLayer" }), t.push({ label: "Lineweight", value: Cs(e.lineweight) }), e.lineTypeScale !== void 0 && e.lineTypeScale !== 1 && t.push({ label: "Linetype scale", value: j(e.lineTypeScale, 3) }), e.visible === !1 && t.push({ label: "Visible", value: "No" }), e.inPaperSpace && t.push({ label: "Space", value: "Paper" }), { title: "General", rows: t };
}, Es = (e) => {
  const [t, a] = e.vertices;
  return {
    title: "Geometry",
    rows: [
      { label: "Start", value: se(t), mono: !0 },
      { label: "End", value: se(a), mono: !0 },
      { label: "Length", value: j(Ms(t, a), 3) }
    ]
  };
}, As = (e) => ({
  title: "Geometry",
  rows: [
    { label: "Center", value: se(e.center), mono: !0 },
    { label: "Radius", value: j(e.radius, 3) },
    { label: "Diameter", value: j(e.radius * 2, 3) },
    { label: "Circumference", value: j(2 * Math.PI * e.radius, 3) }
  ]
}), Ls = (e) => {
  const a = ((e.endAngle - e.startAngle) % 360 + 360) % 360 * Math.PI / 180 * e.radius;
  return {
    title: "Geometry",
    rows: [
      { label: "Center", value: se(e.center), mono: !0 },
      { label: "Radius", value: j(e.radius, 3) },
      { label: "Start angle", value: Ee(e.startAngle) },
      { label: "End angle", value: Ee(e.endAngle) },
      { label: "Arc length", value: j(a, 3) }
    ]
  };
}, $s = (e) => {
  const t = e.majorAxisEndPoint, a = Math.sqrt((t.x ?? 0) ** 2 + (t.y ?? 0) ** 2 + (t.z ?? 0) ** 2);
  return {
    title: "Geometry",
    rows: [
      { label: "Center", value: se(e.center), mono: !0 },
      { label: "Major axis end", value: se(t), mono: !0 },
      { label: "Major axis length", value: j(a, 3) },
      { label: "Axis ratio", value: j(e.axisRatio, 3) },
      // ELLIPSE angles are in radians per DXF spec.
      { label: "Start angle", value: Rt(e.startAngle) },
      { label: "End angle", value: Rt(e.endAngle) }
    ]
  };
}, Ds = (e) => ({
  title: "Geometry",
  rows: [{ label: "Position", value: se(e.position), mono: !0 }]
}), Fs = (e) => {
  const t = [
    { label: "Vertices", value: String(e.vertices.length) },
    { label: "Closed", value: Ht(e.shape) }
  ];
  return e.width !== void 0 && e.width !== 0 && t.push({ label: "Width", value: j(e.width, 3) }), e.isPolyfaceMesh && t.push({ label: "Polyface mesh", value: "Yes" }), e.is3dPolygonMesh && t.push({ label: "3D polygon mesh", value: "Yes" }), { title: "Geometry", rows: t };
}, Bs = (e) => {
  const t = e.controlPoints?.length ?? e.numberOfControlPoints ?? 0, a = e.fitPoints?.length ?? 0, i = [
    { label: "Degree", value: String(e.degree ?? e.degreeOfSplineCurve ?? "—") },
    { label: "Control points", value: String(t) }
  ];
  return a > 0 && i.push({ label: "Fit points", value: String(a) }), e.closed && i.push({ label: "Closed", value: "Yes" }), e.periodic && i.push({ label: "Periodic", value: "Yes" }), { title: "Geometry", rows: i };
}, Ps = (e) => {
  const t = e.type === "SOLID" ? Array.from(e.points) : e.vertices;
  return {
    title: "Geometry",
    rows: [
      { label: "Vertices", value: String(t.length) },
      ...t.slice(0, 4).map((a, i) => ({
        label: `V${i + 1}`,
        value: se(a),
        mono: !0
      }))
    ]
  };
}, zs = (e) => {
  const t = [
    { label: "Pattern", value: e.patternName || "—" },
    { label: "Solid fill", value: Ht(e.solid) },
    { label: "Boundary paths", value: String(e.boundaryPaths.length) }
  ];
  return e.solid || (e.patternScale !== void 0 && t.push({ label: "Pattern scale", value: j(e.patternScale, 3) }), e.patternAngle !== void 0 && t.push({ label: "Pattern angle", value: Ee(e.patternAngle) })), { title: "Geometry", rows: t };
}, Rs = (e) => {
  const t = [
    { label: "Block name", value: e.name },
    { label: "Position", value: se(e.position), mono: !0 }
  ];
  e.rotation !== void 0 && e.rotation !== 0 && t.push({ label: "Rotation", value: Ee(e.rotation) });
  const a = e.xScale ?? 1, i = e.yScale ?? 1, n = e.zScale ?? 1;
  (a !== 1 || i !== 1 || n !== 1) && t.push({
    label: "Scale",
    value: `(${j(a, 3)}, ${j(i, 3)}, ${j(n, 3)})`,
    mono: !0
  });
  const o = e.columnCount ?? 1, f = e.rowCount ?? 1;
  return (o > 1 || f > 1) && t.push({ label: "Array", value: `${o} × ${f}` }), e.attribs && e.attribs.length > 0 && t.push({ label: "ATTRIBs", value: String(e.attribs.length) }), { title: "Geometry", rows: t };
}, Os = {
  0: "Linear",
  1: "Aligned",
  2: "Angular",
  3: "Diameter",
  4: "Radial",
  5: "Angular (3-point)",
  6: "Ordinate"
}, Ns = (e) => {
  const t = [];
  if (e.dimensionType !== void 0) {
    const a = e.dimensionType & 7;
    t.push({
      label: "Dimension type",
      value: Os[a] ?? `Type ${a}`
    });
  }
  return e.styleName && t.push({ label: "Style", value: e.styleName }), e.actualMeasurement !== void 0 && t.push({ label: "Measurement", value: j(e.actualMeasurement, 3) }), e.anchorPoint && t.push({ label: "Definition point", value: se(e.anchorPoint), mono: !0 }), e.middleOfText && t.push({ label: "Text mid", value: se(e.middleOfText), mono: !0 }), { title: "Geometry", rows: t };
}, Is = (e) => {
  const t = [
    { label: "Vertices", value: String(e.vertices.length) }
  ];
  return e.styleName && t.push({ label: "Style", value: e.styleName }), e.arrowHeadFlag === 0 && t.push({ label: "Arrowhead", value: "Off" }), e.pathType === 1 && t.push({ label: "Path type", value: "Spline" }), { title: "Geometry", rows: t };
}, Gs = (e) => {
  const t = e.leaders.reduce(
    (i, n) => i + n.lines.reduce((o, f) => o + f.vertices.length, 0),
    0
  ), a = [
    { label: "Branches", value: String(e.leaders.length) },
    { label: "Vertices total", value: String(t) }
  ];
  return e.textPosition && a.push({ label: "Text position", value: se(e.textPosition), mono: !0 }), { title: "Geometry", rows: a };
}, Us = (e) => {
  const t = [
    { label: "Vertices", value: String(e.numVertices) },
    { label: "Elements", value: String(e.numElements) },
    { label: "Scale", value: j(e.scale, 3) },
    { label: "Justification", value: String(e.justification) }
  ];
  return e.styleName && t.push({ label: "Style", value: e.styleName }), { title: "Geometry", rows: t };
}, Vs = (e) => ({
  title: "Geometry",
  rows: [
    { label: "Base point", value: se(e.basePoint), mono: !0 },
    { label: "Direction", value: se(e.direction), mono: !0 }
  ]
}), Xs = (e) => {
  const t = [];
  return e.tag && t.push({ label: "Tag", value: e.tag }), e.startPoint && t.push({ label: "Position", value: se(e.startPoint), mono: !0 }), e.textHeight !== void 0 && t.push({ label: "Height", value: j(e.textHeight, 3) }), e.rotation !== void 0 && e.rotation !== 0 && t.push({ label: "Rotation", value: Ee(e.rotation) }), { title: "Geometry", rows: t };
}, Hs = (e) => {
  const t = [], a = e.position ?? e.startPoint;
  a && t.push({ label: "Position", value: se(a), mono: !0 });
  const i = e.height ?? e.textHeight;
  return i !== void 0 && t.push({ label: "Height", value: j(i, 3) }), e.rotation !== void 0 && e.rotation !== 0 && t.push({ label: "Rotation", value: Ee(e.rotation) }), e.width !== void 0 && t.push({ label: "Reference width", value: j(e.width, 3) }), { title: "Geometry", rows: t };
}, Ws = (e) => {
  const t = e;
  if (!t.text || typeof t.text != "string") return null;
  const a = [{ label: "Text", value: t.text }], i = t.textStyle ?? t.styleName;
  return i && a.push({ label: "Style", value: i }), { title: "Text", rows: a };
};
function js(e) {
  const t = [Ss(e)], a = Ks(e);
  a && a.rows.length > 0 && t.push(a);
  const i = Ws(e);
  return i && t.push(i), t;
}
function Ks(e) {
  switch (e.type) {
    case "LINE":
      return Es(e);
    case "CIRCLE":
      return As(e);
    case "ARC":
      return Ls(e);
    case "ELLIPSE":
      return $s(e);
    case "POINT":
      return Ds(e);
    case "POLYLINE":
    case "LWPOLYLINE":
      return Fs(e);
    case "SPLINE":
      return Bs(e);
    case "SOLID":
    case "3DFACE":
      return Ps(e);
    case "HATCH":
      return zs(e);
    case "INSERT":
      return Rs(e);
    case "DIMENSION":
      return Ns(e);
    case "LEADER":
      return Is(e);
    case "MULTILEADER":
      return Gs(e);
    case "MLINE":
      return Us(e);
    case "XLINE":
    case "RAY":
      return Vs(e);
    case "ATTRIB":
    case "ATTDEF":
      return Xs(e);
    case "TEXT":
    case "MTEXT":
      return Hs(e);
    default:
      return null;
  }
}
const Ys = ["aria-expanded", "aria-label"], Zs = { class: "dxfk-properties-panel-title" }, Js = { class: "dxfk-properties-panel-type" }, qs = ["title", "aria-label"], Qs = {
  key: 0,
  class: "dxfk-properties-panel-body"
}, _s = {
  key: 0,
  class: "dxfk-properties-empty"
}, eo = { class: "dxfk-properties-section-title" }, to = { class: "dxfk-properties-label" }, no = { class: "dxfk-properties-value-wrap" }, ao = ["title"], so = /* @__PURE__ */ ke({
  __name: "PropertiesPanel",
  props: {
    event: { default: null },
    darkTheme: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, a = U(!0), i = Y(() => t.event?.entity ? js(t.event.entity) : []);
    return (n, o) => (h(), g("div", {
      class: O(["dxfk-properties-panel", [
        { "dxfk-properties-panel--collapsed": !a.value, "dxfk-dark": e.darkTheme }
      ]]),
      role: "region",
      "aria-label": "Entity properties panel"
    }, [
      r("div", {
        class: "dxfk-properties-panel-header",
        role: "button",
        tabindex: "0",
        "aria-expanded": a.value,
        "aria-label": a.value ? "Collapse properties panel" : "Expand properties panel",
        onClick: o[0] || (o[0] = (f) => a.value = !a.value),
        onKeydown: [
          o[1] || (o[1] = de(Q((f) => a.value = !a.value, ["prevent"]), ["enter"])),
          o[2] || (o[2] = de(Q((f) => a.value = !a.value, ["prevent"]), ["space"]))
        ]
      }, [
        r("span", Zs, [
          o[4] || (o[4] = St(" Properties", -1)),
          e.event ? (h(), g(ce, { key: 0 }, [
            o[3] || (o[3] = St(": ", -1)),
            r("code", Js, L(e.event.type), 1)
          ], 64)) : B("", !0)
        ]),
        r("button", {
          class: "dxfk-properties-panel-collapse",
          title: a.value ? "Collapse" : "Expand",
          "aria-label": a.value ? "Collapse" : "Expand",
          tabindex: "-1"
        }, L(a.value ? "−" : "+"), 9, qs)
      ], 40, Ys),
      a.value ? (h(), g("div", Qs, [
        e.event ? (h(!0), g(ce, { key: 1 }, xe(i.value, (f) => (h(), g("div", {
          key: f.title,
          class: "dxfk-properties-section"
        }, [
          r("h4", eo, L(f.title), 1),
          (h(!0), g(ce, null, xe(f.rows, (v) => (h(), g("div", {
            key: v.label,
            class: "dxfk-properties-row"
          }, [
            r("span", to, L(v.label), 1),
            r("span", no, [
              v.swatch ? (h(), g("span", {
                key: 0,
                class: "dxfk-properties-swatch",
                style: ye({ backgroundColor: v.swatch }),
                "aria-hidden": "true"
              }, null, 4)) : B("", !0),
              r("span", {
                class: O(["dxfk-properties-value", { "dxfk-properties-value--mono": v.mono }]),
                title: v.value
              }, L(v.value), 11, ao)
            ])
          ]))), 128))
        ]))), 128)) : (h(), g("div", _s, " Click an entity to inspect its properties. "))
      ])) : B("", !0)
    ], 2));
  }
}), oo = /* @__PURE__ */ be(so, [["__scopeId", "data-v-d49e26b4"]]), ro = ["title", "aria-label", "aria-pressed"], lo = ["title", "aria-label", "aria-pressed"], io = ["title", "aria-label", "aria-pressed"], co = ["title", "aria-label", "aria-pressed"], uo = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, fo = {
  key: 1,
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, vo = /* @__PURE__ */ ke({
  __name: "ViewerToolbar",
  props: {
    showExportButton: { type: Boolean, default: !1 },
    showResetButton: { type: Boolean, default: !1 },
    showFullscreenButton: { type: Boolean, default: !0 },
    showMeasureButton: { type: Boolean, default: !1 },
    measureActive: { type: Boolean, default: !1 },
    showMeasureAreaButton: { type: Boolean, default: !1 },
    measureAreaActive: { type: Boolean, default: !1 },
    showMeasureAngleButton: { type: Boolean, default: !1 },
    measureAngleActive: { type: Boolean, default: !1 },
    isFullscreen: { type: Boolean, default: !1 },
    darkTheme: { type: Boolean, default: !1 }
  },
  emits: ["export", "reset-view", "toggle-fullscreen", "toggle-measure", "toggle-measure-area", "toggle-measure-angle"],
  setup(e) {
    return (t, a) => (h(), g("div", {
      class: O(["dxfk-toolbar", { "dxfk-dark": e.darkTheme }]),
      role: "toolbar",
      "aria-label": "DXF viewer toolbar"
    }, [
      e.showExportButton ? (h(), g("button", {
        key: 0,
        class: "dxfk-toolbar-button",
        onClick: a[0] || (a[0] = (i) => t.$emit("export")),
        title: "Export PNG",
        "aria-label": "Export current view as PNG"
      }, [...a[6] || (a[6] = [
        r("svg", {
          width: "20",
          height: "20",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          r("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
          r("polyline", { points: "7 10 12 15 17 10" }),
          r("line", {
            x1: "12",
            y1: "15",
            x2: "12",
            y2: "3"
          })
        ], -1)
      ])])) : B("", !0),
      e.showMeasureButton ? (h(), g("button", {
        key: 1,
        class: O(["dxfk-toolbar-button", { "dxfk-toolbar-button--active": e.measureActive }]),
        onClick: a[1] || (a[1] = (i) => t.$emit("toggle-measure")),
        title: e.measureActive ? "Disable measure tool" : "Measure distance",
        "aria-label": e.measureActive ? "Disable measure tool" : "Enable measure-distance tool",
        "aria-pressed": e.measureActive
      }, [...a[7] || (a[7] = [
        ve('<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-v-3091d19a><path d="M3 17 17 3l4 4L7 21z" data-v-3091d19a></path><path d="M14 6l2 2" data-v-3091d19a></path><path d="M11 9l2 2" data-v-3091d19a></path><path d="M8 12l2 2" data-v-3091d19a></path><path d="M5 15l2 2" data-v-3091d19a></path></svg>', 1)
      ])], 10, ro)) : B("", !0),
      e.showMeasureAreaButton ? (h(), g("button", {
        key: 2,
        class: O(["dxfk-toolbar-button", { "dxfk-toolbar-button--active": e.measureAreaActive }]),
        onClick: a[2] || (a[2] = (i) => t.$emit("toggle-measure-area")),
        title: e.measureAreaActive ? "Disable area tool" : "Measure area",
        "aria-label": e.measureAreaActive ? "Disable area-measurement tool" : "Enable area-measurement tool",
        "aria-pressed": e.measureAreaActive
      }, [...a[8] || (a[8] = [
        ve('<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-v-3091d19a><polygon points="12 3 21 9.5 17.5 20.5 6.5 20.5 3 9.5" data-v-3091d19a></polygon><circle cx="12" cy="3" r="1.4" fill="currentColor" stroke="none" data-v-3091d19a></circle><circle cx="21" cy="9.5" r="1.4" fill="currentColor" stroke="none" data-v-3091d19a></circle><circle cx="17.5" cy="20.5" r="1.4" fill="currentColor" stroke="none" data-v-3091d19a></circle><circle cx="6.5" cy="20.5" r="1.4" fill="currentColor" stroke="none" data-v-3091d19a></circle><circle cx="3" cy="9.5" r="1.4" fill="currentColor" stroke="none" data-v-3091d19a></circle></svg>', 1)
      ])], 10, lo)) : B("", !0),
      e.showMeasureAngleButton ? (h(), g("button", {
        key: 3,
        class: O(["dxfk-toolbar-button", { "dxfk-toolbar-button--active": e.measureAngleActive }]),
        onClick: a[3] || (a[3] = (i) => t.$emit("toggle-measure-angle")),
        title: e.measureAngleActive ? "Disable angle tool" : "Measure angle",
        "aria-label": e.measureAngleActive ? "Disable angle-measurement tool" : "Enable angle-measurement tool",
        "aria-pressed": e.measureAngleActive
      }, [...a[9] || (a[9] = [
        r("svg", {
          width: "20",
          height: "20",
          viewBox: "0 0 122.88 103.56",
          fill: "currentColor",
          "aria-hidden": "true"
        }, [
          r("path", { d: "M59.49,1.72c1.03-1.69,3.24-2.23,4.94-1.2c1.69,1.03,2.23,3.24,1.2,4.94L34.75,55.92c6.65,4.72,12.18,10.9,16.11,18.07 c3.69,6.72,5.99,14.31,6.51,22.37h61.91c1.99,0,3.6,1.61,3.6,3.6c0,1.99-1.61,3.6-3.6,3.6H3.59v-0.01c-0.64,0-1.29-0.17-1.87-0.53 c-1.69-1.03-2.23-3.24-1.2-4.94L59.49,1.72L59.49,1.72z M31,62.05L10.01,96.36h40.14c-0.51-6.82-2.47-13.23-5.59-18.91 C41.22,71.36,36.57,66.1,31,62.05L31,62.05z" })
        ], -1)
      ])], 10, io)) : B("", !0),
      e.showResetButton ? (h(), g("button", {
        key: 4,
        class: "dxfk-toolbar-button",
        onClick: a[4] || (a[4] = (i) => t.$emit("reset-view")),
        title: "Fit to View",
        "aria-label": "Reset camera and fit drawing to view"
      }, [...a[10] || (a[10] = [
        ve('<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-v-3091d19a><circle cx="12" cy="12" r="7" data-v-3091d19a></circle><line x1="12" y1="2" x2="12" y2="5" data-v-3091d19a></line><line x1="12" y1="19" x2="12" y2="22" data-v-3091d19a></line><line x1="2" y1="12" x2="5" y2="12" data-v-3091d19a></line><line x1="19" y1="12" x2="22" y2="12" data-v-3091d19a></line></svg>', 1)
      ])])) : B("", !0),
      e.showFullscreenButton ? (h(), g("button", {
        key: 5,
        class: "dxfk-toolbar-button",
        onClick: a[5] || (a[5] = (i) => t.$emit("toggle-fullscreen")),
        title: e.isFullscreen ? "Exit Fullscreen" : "Fullscreen",
        "aria-label": e.isFullscreen ? "Exit fullscreen" : "Enter fullscreen",
        "aria-pressed": e.isFullscreen
      }, [
        e.isFullscreen ? (h(), g("svg", fo, [...a[12] || (a[12] = [
          r("path", { d: "M8 4v4H4" }, null, -1),
          r("path", { d: "M16 4v4h4" }, null, -1),
          r("path", { d: "M4 16h4v4" }, null, -1),
          r("path", { d: "M20 16h-4v4" }, null, -1)
        ])])) : (h(), g("svg", uo, [...a[11] || (a[11] = [
          r("path", { d: "M4 8V4h4" }, null, -1),
          r("path", { d: "M16 4h4v4" }, null, -1),
          r("path", { d: "M20 16v4h-4" }, null, -1),
          r("path", { d: "M4 16v4h4" }, null, -1)
        ])]))
      ], 8, co)) : B("", !0),
      we(t.$slots, "extra", {}, void 0, !0)
    ], 2));
  }
}), ho = /* @__PURE__ */ be(vo, [["__scopeId", "data-v-3091d19a"]]);
function mo(e, t, a) {
  if (!Number.isFinite(e) || !Number.isFinite(t) || !Number.isFinite(a))
    return 1;
  const i = Math.abs(e);
  if (i === 0 || t <= 0 || a <= 0) return 1;
  const n = i * (a / t), o = Math.pow(10, Math.floor(Math.log10(n))), f = n / o;
  let v;
  return f < 1.5 ? v = 1 : f < 3.5 ? v = 2 : f < 7.5 ? v = 5 : v = 10, v * o;
}
function go(e, t) {
  if (!Number.isFinite(e)) return "";
  Object.is(e, -0) && (e = 0);
  const a = Math.abs(t) || 1, i = Math.round(e / a) * a, n = Math.abs(i);
  if (n !== 0 && (n >= 1e6 || n < 1e-3))
    return i.toExponential(1).replace(/\.0e/, "e").replace("e+", "e+").replace("e-", "e-");
  const o = a >= 1 ? 0 : Math.min(10, Math.ceil(-Math.log10(a)));
  let f = i.toFixed(o);
  return o > 0 && (f = f.replace(/\.?0+$/, "")), f === "-0" && (f = "0"), f;
}
const Ue = 10, Ot = 4, Nt = 2, po = 80, yo = "10px system-ui, -apple-system, sans-serif", xo = /* @__PURE__ */ ke({
  __name: "Ruler",
  props: {
    orientation: {},
    camera: {},
    controls: {},
    originOffset: {},
    cursorWorld: {},
    isCursorVisible: { type: Boolean },
    unitsScale: {},
    darkTheme: { type: Boolean }
  },
  setup(e) {
    const t = e, a = U(null), i = U(null);
    let n = null, o = null, f = { width: 0, height: 0 };
    const v = () => {
      o === null && (o = requestAnimationFrame(() => {
        o = null, p();
      }));
    }, T = () => {
      const C = i.value, m = a.value;
      if (!C || !m) return;
      const R = m.getBoundingClientRect();
      f.width = R.width, f.height = R.height;
      const z = window.devicePixelRatio || 1, d = Math.round(R.width * z), u = Math.round(R.height * z);
      (C.width !== d || C.height !== u) && (C.width = d, C.height = u, C.style.width = `${R.width}px`, C.style.height = `${R.height}px`);
    }, p = () => {
      const C = i.value;
      if (!C) return;
      T();
      const m = C.getContext("2d");
      if (!m) return;
      const R = window.devicePixelRatio || 1;
      m.setTransform(R, 0, 0, R, 0, 0);
      const { width: z, height: d } = f;
      m.clearRect(0, 0, z, d);
      const u = x("--dxfk-ruler-bg", t.darkTheme ? "#1f1f1f" : "#fafafa"), l = x("--dxfk-ruler-tick", t.darkTheme ? "#888" : "#999"), y = x("--dxfk-ruler-text", t.darkTheme ? "#ddd" : "#333"), X = x("--dxfk-ruler-cursor", t.darkTheme ? "#ffaa00" : "#1040b0");
      m.fillStyle = u, m.fillRect(0, 0, z, d), m.strokeStyle = l, m.lineWidth = 1, m.beginPath(), t.orientation === "horizontal" ? (m.moveTo(0, d - 0.5), m.lineTo(z, d - 0.5)) : (m.moveTo(z - 0.5, 0), m.lineTo(z - 0.5, d)), m.stroke();
      const _ = t.camera ? Ut(t.camera) : null;
      if (!_ || z <= 0 || d <= 0) return;
      const V = t.orientation === "horizontal", ee = V ? (_.right - _.left) / 2 / _.zoom : (_.top - _.bottom) / 2 / _.zoom, $ = V ? _.position.x : _.position.y, k = V ? t.originOffset.x : t.originOffset.y, ne = $ - ee + k, ae = $ + ee + k;
      if (ae - ne === 0) return;
      const q = ne * t.unitsScale, re = ae * t.unitsScale, I = re - q, E = (V ? z : d) / I, S = mo(Math.abs(I), V ? z : d, po), G = S / 5, K = Math.min(q, re), le = Math.max(q, re), Z = Math.ceil(K / S) * S, me = Math.ceil(K / G) * G;
      m.font = yo, m.textBaseline = V ? "alphabetic" : "middle", m.textAlign = V ? "center" : "left", m.fillStyle = y, m.strokeStyle = l;
      const H = (P) => V ? (P - q) * E : d - (P - q) * E;
      m.beginPath();
      for (let P = me; P <= le + G * 0.5; P += G) {
        if (Math.abs(P / S - Math.round(P / S)) < 1e-6) continue;
        const A = H(P);
        V ? (m.moveTo(Math.round(A) + 0.5, d), m.lineTo(Math.round(A) + 0.5, d - Ot)) : (m.moveTo(z, Math.round(A) + 0.5), m.lineTo(z - Ot, Math.round(A) + 0.5));
      }
      m.stroke(), m.beginPath();
      for (let P = Z; P <= le + S * 0.5; P += S) {
        const A = H(P);
        V ? (m.moveTo(Math.round(A) + 0.5, d), m.lineTo(Math.round(A) + 0.5, d - Ue)) : (m.moveTo(z, Math.round(A) + 0.5), m.lineTo(z - Ue, Math.round(A) + 0.5));
      }
      m.stroke();
      for (let P = Z; P <= le + S * 0.5; P += S) {
        const A = H(P), oe = go(P, S);
        oe && (V ? m.fillText(oe, Math.round(A), d - Ue - Nt) : (m.save(), m.translate(z - Ue - Nt, Math.round(A)), m.rotate(-Math.PI / 2), m.textAlign = "center", m.textBaseline = "alphabetic", m.fillText(oe, 0, 0), m.restore()));
      }
      if (t.isCursorVisible) {
        const P = (V ? t.cursorWorld.x : t.cursorWorld.y) * t.unitsScale;
        if (P >= K && P <= le) {
          const A = H(P);
          m.strokeStyle = X, m.lineWidth = 1, m.beginPath(), V ? (m.moveTo(Math.round(A) + 0.5, 0), m.lineTo(Math.round(A) + 0.5, d)) : (m.moveTo(0, Math.round(A) + 0.5), m.lineTo(z, Math.round(A) + 0.5)), m.stroke();
        }
      }
    }, x = (C, m) => {
      const R = a.value;
      return R && getComputedStyle(R).getPropertyValue(C).trim() || m;
    }, M = () => v(), D = () => {
      t.controls && t.controls.addEventListener("change", M);
    }, F = (C) => {
      C && C.removeEventListener("change", M);
    };
    return ot(() => {
      a.value && (n = new ResizeObserver(() => v()), n.observe(a.value)), D(), v();
    }), rt(() => {
      n && (n.disconnect(), n = null), o !== null && (cancelAnimationFrame(o), o = null), F(t.controls);
    }), J(
      () => t.controls,
      (C, m) => {
        m && F(m), C && C.addEventListener("change", M), v();
      }
    ), J(
      () => [
        t.cursorWorld.x,
        t.cursorWorld.y,
        t.isCursorVisible,
        t.unitsScale,
        t.darkTheme,
        t.originOffset.x,
        t.originOffset.y
      ],
      () => v()
    ), (C, m) => (h(), g("div", {
      ref_key: "rootEl",
      ref: a,
      class: O(["dxfk-ruler", [e.orientation === "horizontal" ? "dxfk-ruler-h" : "dxfk-ruler-v", { "dxfk-dark": e.darkTheme }]]),
      "aria-hidden": "true"
    }, [
      r("canvas", {
        ref_key: "canvasEl",
        ref: i
      }, null, 512)
    ], 2));
  }
}), It = /* @__PURE__ */ be(xo, [["__scopeId", "data-v-cc513f0b"]]), ko = ["aria-busy"], bo = {
  key: 0,
  class: "dxfk-message-overlay"
}, wo = { class: "dxfk-coord-row" }, Co = { class: "dxfk-coord-row" }, Mo = {
  key: 1,
  class: "dxfk-coord-row"
}, To = { class: "dxfk-coord-value dxfk-zoom-value" }, So = { class: "dxfk-message-content" }, Eo = { class: "dxfk-message-text" }, Ao = {
  key: 0,
  class: "dxfk-progress-container"
}, Lo = {
  key: 1,
  class: "dxfk-progress-text"
}, $o = { class: "dxfk-message-content" }, Do = { class: "dxfk-message-text" }, Fo = { class: "dxfk-measure-area-row" }, Bo = { class: "dxfk-measure-area-row dxfk-measure-area-row--secondary" }, Po = /* @__PURE__ */ ke({
  __name: "DXFViewer",
  props: {
    dxfData: { default: null },
    fileName: { default: "" },
    url: { default: "" },
    showResetButton: { type: Boolean, default: !1 },
    showFullscreenButton: { type: Boolean, default: !0 },
    autoFit: { type: Boolean, default: !0 },
    showCoordinates: { type: Boolean, default: !1 },
    showZoomLevel: { type: Boolean, default: !1 },
    showDebugInfo: { type: Boolean, default: !1 },
    showFileName: { type: Boolean, default: !0 },
    showExportButton: { type: Boolean, default: !1 },
    showLayerPanel: { type: Boolean, default: !0 },
    groupLayers: { type: [Boolean, Object], default: !1 },
    showPropertiesPanel: { type: Boolean, default: !1 },
    allowDrop: { type: Boolean, default: !1 },
    darkTheme: { type: Boolean, default: !1 },
    fontUrl: { default: "" },
    antialiasing: { default: "msaa" },
    fileNamePosition: { default: "top-left" },
    toolbarPosition: { default: "top-right" },
    coordinatesPosition: { default: "bottom-left" },
    debugPosition: { default: "bottom-center" },
    layerPanelPosition: { default: "bottom-right" },
    propertiesPanelPosition: { default: "top-left" },
    overlayPosition: { default: "top-center" },
    pickingEnabled: { type: Boolean, default: !1 },
    highlightOnHover: { type: Boolean, default: !0 },
    highlightAssociated: { type: Boolean, default: !0 },
    highlightColor: { default: "#ffaa00" },
    pickingDebug: { type: Boolean, default: !1 },
    persistLayersKey: { default: "" },
    hiddenLayers: {},
    keyboardNavigation: { type: Boolean, default: !0 },
    classes: { default: () => ({}) },
    showRulers: { type: Boolean, default: !1 },
    rulerUnits: { default: "mm" },
    rectangleSelection: { type: Boolean, default: !1 },
    rectangleSelectionModifier: { default: "shift" },
    rectangleSelectionMode: { default: "auto" },
    measureMode: { default: "none" },
    showMeasureButton: { type: Boolean, default: !1 },
    showMeasureAreaButton: { type: Boolean, default: !1 },
    showMeasureAngleButton: { type: Boolean, default: !1 },
    measureUnits: {},
    measureAreaUnits: { default: "auto" },
    measureAngleUnits: { default: "deg" },
    measureColor: { default: "#ff6b1a" },
    snapToGeometry: { type: Boolean, default: !0 }
  },
  emits: ["dxf-loaded", "dxf-data", "error", "unsupported-entities", "reset-view", "file-dropped", "entity-hover", "entity-click", "layer-hover", "entities-select", "selection-start", "selection-end", "update:hiddenLayers", "update:measureMode", "measure", "measure-area", "measure-angle", "measure-cancel"],
  setup(e, { expose: t, emit: a }) {
    const i = [
      "top-left",
      "top-center",
      "top-right",
      "bottom-left",
      "bottom-center",
      "bottom-right"
    ], n = e, o = a, f = U(null), { isFullscreen: v, toggleFullscreen: T } = Pa(() => f.value), p = U(null), x = U(null), {
      isLoading: M,
      displayProgress: D,
      zoomPercent: F,
      debugInfo: C,
      webGLSupported: m,
      error: R,
      initThreeJS: z,
      parseDXFAsync: d,
      displayDXF: u,
      handleResize: l,
      resetView: y,
      zoomToBox: X,
      applyLayerVisibility: _,
      switchTheme: V,
      cleanup: ee,
      getCamera: $,
      getRenderer: k,
      getScene: ne,
      getControls: ae,
      getOriginOffset: te,
      render: q
    } = pa(), re = Ca({
      getCamera: $,
      getControls: ae,
      resetView: () => {
        qe();
      },
      render: () => q()
    }), I = ka(), E = ba(), S = wa(), G = S.screenRect, K = Ma(), le = K.state, Z = Sa(), me = Z.state, H = Aa(), P = H.state, A = La();
    let oe = null;
    const ie = U(null), ge = (s) => {
      if (!n.pickingEnabled) return;
      const c = ne();
      if (!c) return;
      const w = te(), W = { x: w.x, y: w.y, z: w.z };
      I.installPickingData(s, c, W), E.init(c, W, n.highlightColor);
      const fe = I.getEntityIndex(), he = I.getPickingIndex();
      fe && he && E.installHighlightData(fe, he), he && S.installRectData(he, W), n.pickingDebug && I.setDebug(!0), oe = s;
    }, pe = () => {
      E.removeHighlightData(), E.dispose(), I.removePickingData(ne()), S.removeRectData(), oe = null, ie.value = null;
    }, Ce = (s) => {
      const c = s ?? Be.value;
      if (!n.snapToGeometry || !c) {
        A.setData(null, null);
        return;
      }
      const w = I.getPickingIndex(), W = I.getEntityIndex();
      if (w && W) {
        A.setData(w, W);
        return;
      }
      if (n.measureMode === "none") {
        A.setData(null, null);
        return;
      }
      A.setData(aa(c), Ft(c));
    }, Wt = (s) => {
      if (o("entity-hover", s), !!n.highlightOnHover) {
        if (!s)
          E.clear();
        else {
          const c = jt(s);
          c.length > 0 && E.highlight(c);
        }
        q();
      }
    }, jt = (s) => {
      if (n.highlightAssociated && s.association) {
        const c = [];
        for (const w of s.association.members)
          c.push(...I.getPickingEntries(w));
        return c;
      }
      if (s.pickId) {
        const c = I.getPickingEntryById(s.pickId);
        if (c) return [c];
      }
      return [];
    }, Kt = (s) => {
      ie.value = s, o("entity-click", s);
    }, Yt = (s) => {
      if (o("layer-hover", s), !n.highlightOnHover) return;
      if (!s) {
        E.clear(), q();
        return;
      }
      const c = Be.value;
      if (!c) return;
      const w = sa(c, s);
      if (w.length === 0) {
        E.clear(), q();
        return;
      }
      const W = [];
      for (const fe of w) W.push(...I.getPickingEntries(fe));
      E.highlight(W), q();
    }, Zt = (s) => {
      o("selection-start", s);
    }, Jt = (s, c) => {
      const w = s.map((W) => I.buildEventForEntry(W));
      o("entities-select", w);
    }, qt = () => {
      o("selection-end");
    }, Qt = (s) => {
      o("measure", s);
    }, _t = (s) => {
      o("measure-area", s);
    }, en = (s) => {
      o("measure-angle", s);
    }, Xe = () => {
      o("measure-cancel");
    }, Fe = () => {
      I.setEnabled(!1), S.setEnabled(!1);
    }, tn = () => {
      I.setEnabled(n.pickingEnabled), S.setEnabled(n.rectangleSelection && n.pickingEnabled);
    }, nn = () => {
      const s = k(), c = $(), w = ne();
      if (!s || !c || !w) return;
      const W = ae(), fe = () => q();
      A.attach(s.domElement, w, c, te, fe), A.setColor(n.measureColor), A.setEnabled(n.snapToGeometry), Ce();
      const he = (Ne, Dn, Fn) => A.resolve(Ne, Dn, Fn);
      K.attach(s.domElement, w, c, W, te, fe, {
        onResult: Qt,
        onCancel: Xe,
        snap: he
      }), K.setColor(n.measureColor), K.setUnitsScale(Ze.value, Ye.value), Z.attach(s.domElement, w, c, W, te, fe, {
        onResult: _t,
        onCancel: Xe,
        snap: he
      }), Z.setColor(n.measureColor), Z.setUnits(Je.value), H.attach(s.domElement, w, c, W, te, fe, {
        onResult: en,
        onCancel: Xe,
        snap: he
      }), H.setColor(n.measureColor), H.setUnits(n.measureAngleUnits), n.measureMode === "distance" ? (K.setEnabled(!0), Fe()) : n.measureMode === "area" ? (Z.setEnabled(!0), Fe()) : n.measureMode === "angle" && (H.setEnabled(!0), Fe());
    }, He = () => {
      if (!n.rectangleSelection || !n.pickingEnabled) return;
      const s = k(), c = $();
      !s || !c || (S.attach(
        s.domElement,
        c,
        ae(),
        {
          onStart: Zt,
          onSelect: Jt,
          onEnd: qt
        }
      ), S.setModifier(n.rectangleSelectionModifier), S.setMode(n.rectangleSelectionMode), S.setEnabled(!0));
    }, an = (s) => {
      const c = [];
      for (const w of s)
        c.push(...I.getPickingEntries(w));
      E.highlight(c), q();
    }, sn = () => {
      E.clear(), q();
    }, on = () => I.getAssociations(), rn = (s) => I.findAssociationsByHandle(s), ln = (s) => {
      const c = I.getPickingIndex();
      if (!c) return;
      const w = oa(c, s, { originOffset: te() });
      w && X(w);
    }, cn = (s) => {
      const c = I.getPickingIndex();
      if (!c) return;
      const w = ra(c, s, { originOffset: te() });
      w && X(w);
    }, ue = U(""), { errorMessage: We, setError: un, clearError: je } = xa(), lt = (s) => s >= 1e6 ? (s / 1e6).toFixed(1) + "M" : s >= 1e3 ? (s / 1e3).toFixed(1) + "K" : String(s), { cursorX: it, cursorY: ct, isCursorVisible: Me, cursorWorld: ut, handleMouseMove: dt, handleMouseLeave: ft } = Fa({
      getContainer: () => f.value,
      getCamera: $,
      getOriginOffset: te,
      isTracking: () => n.showCoordinates || n.showRulers
    }), { isDragOver: dn, handleDragOver: vt, handleDragLeave: ht, handleDrop: mt, loadDXFFromBuffer: fn, loadDXFFromBlob: vn } = Ba({
      allowDrop: () => n.allowDrop,
      loadText: (s) => tt(s),
      onFileDropped: (s) => o("file-dropped", s)
    }), {
      layerList: gt,
      visibleLayerNames: hn,
      hiddenLayerNames: mn,
      initLayers: gn,
      toggleLayerVisibility: pn,
      showAllLayers: yn,
      hideAllLayers: xn,
      setHiddenLayers: kn,
      updateLayerThemeColors: bn,
      clearLayers: wn
    } = ya({
      getStorageKey: () => n.persistLayersKey ? `${n.persistLayersKey}:${n.fileName || "default"}` : null,
      getControlledHidden: () => n.hiddenLayers,
      onChange: (s) => o("update:hiddenLayers", s)
    }), Cn = (s) => {
      const c = mn.value;
      if (s.length !== c.length) return !1;
      const w = new Set(s);
      for (const W of c) if (!w.has(W)) return !1;
      return !0;
    };
    let pt = null;
    const Ke = U(null), Be = Y(() => n.dxfData ?? Ke.value), Te = Y(() => {
      const s = Be.value;
      return !!(s && s.entities && s.entities.length > 0);
    }), {
      rulerUnitsScale: yt,
      rulerUnitsLabel: Mn,
      currentMeasureUnits: Ye,
      measureUnitsScale: Ze,
      areaUnitScales: Je
    } = $a({
      activeDxf: Be,
      rulerUnits: () => n.rulerUnits,
      measureUnits: () => n.measureUnits,
      measureAreaUnits: () => n.measureAreaUnits
    }), { bumpCameraTick: Tn, measureLabel: Pe, areaLabel: Ae, angleLabel: ze } = Da({
      getCamera: $,
      getContainer: () => f.value,
      getOriginOffset: te,
      measureState: le,
      areaState: me,
      angleState: P,
      measureUnitsScale: Ze,
      currentMeasureUnits: Ye,
      areaUnitScales: Je,
      measureAngleUnits: () => n.measureAngleUnits
    }), Le = U({ x: 0, y: 0 }), xt = () => {
      const s = te();
      (Le.value.x !== s.x || Le.value.y !== s.y) && (Le.value = { x: s.x, y: s.y });
    }, qe = () => {
      y(), o("reset-view");
    }, Qe = () => {
      const s = k();
      if (!s) return;
      const c = document.createElement("a");
      c.download = (n.fileName || "dxf-export").replace(/\.dxf$/i, "") + ".png", c.href = s.domElement.toDataURL("image/png"), c.click();
    }, Sn = () => {
      n.url ? Oe(n.url) : n.dxfData && Te.value && Re(n.dxfData);
    }, kt = (s, c) => {
      const w = s.tables?.layer?.layers || {}, W = {}, fe = Ft(s);
      for (const he of fe.values()) {
        const Ne = he.layer || "0";
        W[Ne] = (W[Ne] || 0) + 1;
      }
      gn(w, W, c);
    }, Se = () => {
      const s = hn.value;
      _(s), I.setVisibleLayers(s), S.setVisibleLayers(s), A.setVisibleLayers(s);
    }, En = (s) => {
      pn(s), Se();
    }, An = () => {
      yn(), Se();
    }, Ln = () => {
      xn(), Se();
    }, _e = (s, c) => {
      wn();
      const w = un(s, c);
      o("error", w), o("dxf-loaded", !1), o("dxf-data", null);
    }, et = () => {
      K.clear(), Z.clear(), H.clear();
    }, tt = async (s) => {
      je(), ie.value = null, et(), M.value = !0;
      try {
        ue.value = "parsing";
        const c = await d(s);
        pt = c, Ke.value = c, ue.value = "rendering";
        const w = await u(c, n.darkTheme, n.fontUrl);
        kt(c, n.darkTheme), Se(), ge(c), Ce(c), xt(), o("dxf-loaded", !0), o("dxf-data", c), w && w.length > 0 && o("unsupported-entities", w);
      } catch (c) {
        _e(c, "Unknown error loading DXF");
      } finally {
        ue.value = "", M.value = !1;
      }
    }, Re = async (s) => {
      je(), ie.value = null, et(), M.value = !0, ue.value = "rendering", Ke.value = s;
      try {
        const c = await u(s, n.darkTheme, n.fontUrl);
        kt(s, n.darkTheme), Se(), ge(s), Ce(s), xt(), o("dxf-loaded", !0), o("dxf-data", s), c && c.length > 0 && o("unsupported-entities", c);
      } catch (c) {
        _e(c, "Unknown error displaying DXF");
      } finally {
        ue.value = "", M.value = !1;
      }
    }, Oe = async (s) => {
      je(), M.value = !0, ue.value = "fetching";
      try {
        const c = await fetch(s);
        if (!c.ok) throw new Error(`HTTP ${c.status}: ${c.statusText}`);
        const w = await c.text();
        await tt(w);
      } catch (c) {
        _e(c, "Failed to fetch DXF");
      } finally {
        ue.value = "", M.value = !1;
      }
    }, bt = () => {
      f.value && l(f.value);
    };
    J(
      () => n.dxfData,
      (s) => {
        s && Te.value && Ut(s) !== pt && Re(s);
      }
    ), J(
      () => n.url,
      (s) => {
        s && Oe(s);
      }
    ), J(
      () => n.darkTheme,
      (s) => {
        V(s), bn(s);
      }
    ), J(R, (s) => {
      s && o("error", s);
    }), J(
      () => n.pickingEnabled,
      (s) => {
        if (I.setEnabled(s), !s)
          pe(), S.detach();
        else if (oe == null) {
          const c = n.dxfData ?? null;
          c && c.entities?.length && ge(c);
        }
        s && (wt(), He()), Ce();
      }
    ), J(
      () => n.rectangleSelection,
      (s) => {
        s ? He() : S.detach();
      }
    ), J(
      () => n.rectangleSelectionModifier,
      (s) => S.setModifier(s)
    ), J(
      () => n.rectangleSelectionMode,
      (s) => S.setMode(s)
    ), J(
      () => n.highlightColor,
      (s) => {
        E.setColor(s);
      }
    ), J(
      () => n.measureColor,
      (s) => {
        K.setColor(s), Z.setColor(s), H.setColor(s), A.setColor(s);
      }
    ), J(
      () => n.snapToGeometry,
      (s) => {
        A.setEnabled(s), Ce();
      }
    ), J(
      [Ze, Ye],
      ([s, c]) => K.setUnitsScale(s, c)
    ), J(Je, (s) => Z.setUnits(s)), J(
      () => n.measureAngleUnits,
      (s) => H.setUnits(s)
    ), J(
      () => n.measureMode,
      (s) => {
        s !== "distance" && K.setEnabled(!1), s !== "area" && Z.setEnabled(!1), s !== "angle" && H.setEnabled(!1), s === "distance" && K.setEnabled(!0), s === "area" && Z.setEnabled(!0), s === "angle" && H.setEnabled(!0), s === "none" ? tn() : Fe(), A.clear(), s !== "none" && Ce();
      }
    ), J(
      () => n.hiddenLayers,
      (s) => {
        s !== void 0 && (Cn(s) || (kn(s), Se()));
      },
      { deep: !0 }
    ), J(
      () => n.pickingDebug,
      (s) => {
        I.setDebug(s), q();
      }
    ), J(
      () => n.keyboardNavigation,
      (s) => {
        if (re.setEnabled(s), s) {
          const c = k();
          c && re.attach(c.domElement);
        } else
          re.detach();
      }
    );
    const wt = () => {
      if (!n.pickingEnabled) return;
      const s = k(), c = $();
      !s || !c || I.attach(s.domElement, c, {
        onHover: Wt,
        onClick: Kt
      });
    };
    let $e = null;
    ot(() => {
      zn(() => {
        if (f.value) {
          z(f.value, { enableControls: !0, aaMode: n.antialiasing });
          const s = ae();
          s && s.addEventListener("change", () => {
            Tn();
          }), wt(), He(), nn();
          const c = $();
          p.value = c ? Et(c) : null;
          const w = ae();
          x.value = w ? Et(w) : null;
          const W = k();
          W && n.keyboardNavigation && re.attach(W.domElement), n.url ? Oe(n.url) : n.dxfData && Te.value && Re(n.dxfData), $e = new ResizeObserver(() => {
            bt();
          }), $e.observe(f.value);
        }
      });
    }), rt(() => {
      $e && ($e.disconnect(), $e = null), I.detach(), S.detach(), K.dispose(), Z.dispose(), H.dispose(), A.dispose(), re.detach(), pe(), ee();
    });
    const Ct = () => {
      o("update:measureMode", n.measureMode === "distance" ? "none" : "distance");
    }, Mt = () => {
      o("update:measureMode", n.measureMode === "area" ? "none" : "area");
    }, Tt = () => {
      o("update:measureMode", n.measureMode === "angle" ? "none" : "angle");
    }, $n = (s) => {
      o("update:measureMode", s);
    };
    return t({
      loadDXFFromText: tt,
      loadDXFFromData: Re,
      loadDXFFromUrl: Oe,
      loadDXFFromBuffer: fn,
      loadDXFFromBlob: vn,
      resize: bt,
      resetView: y,
      exportToPNG: Qe,
      getRenderer: k,
      highlight: an,
      clearHighlight: sn,
      clearSelection: () => {
        ie.value = null;
      },
      getAssociations: on,
      findAssociationsByHandle: rn,
      zoomToEntity: ln,
      zoomToLayer: cn,
      getPickingIndex: I.getPickingIndex,
      clearMeasure: et,
      setMeasureMode: $n
    }), (s, c) => (h(), g("div", {
      ref_key: "dxfContainer",
      ref: f,
      class: O(["dxfk-viewer", [{ "dxfk-dark": e.darkTheme }, e.classes?.root]]),
      role: "region",
      "aria-label": "DXF drawing viewer",
      "aria-busy": b(M),
      onMousemove: c[0] || (c[0] = //@ts-ignore
      (...w) => b(dt) && b(dt)(...w)),
      onMouseleave: c[1] || (c[1] = //@ts-ignore
      (...w) => b(ft) && b(ft)(...w)),
      onDragover: c[2] || (c[2] = Q(
        //@ts-ignore
        (...w) => b(vt) && b(vt)(...w),
        ["prevent"]
      )),
      onDragleave: c[3] || (c[3] = //@ts-ignore
      (...w) => b(ht) && b(ht)(...w)),
      onDrop: c[4] || (c[4] = Q(
        //@ts-ignore
        (...w) => b(mt) && b(mt)(...w),
        ["prevent"]
      ))
    }, [
      b(m) ? B("", !0) : (h(), g("div", bo, [...c[5] || (c[5] = [
        ve('<div class="dxfk-message-content" data-v-d530ed4a><svg class="dxfk-message-icon dxfk-message-icon--error" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" data-v-d530ed4a><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" data-v-d530ed4a></path><line x1="12" y1="9" x2="12" y2="14" data-v-d530ed4a></line><circle cx="12" cy="17" r="1" fill="currentColor" stroke="none" data-v-d530ed4a></circle></svg><div class="dxfk-message-title" data-v-d530ed4a>WebGL Not Supported</div><div class="dxfk-message-text" data-v-d530ed4a>Update your browser or enable hardware acceleration</div></div>', 1)
      ])])),
      Te.value && e.showRulers ? (h(), g(ce, { key: 1 }, [
        Ve(It, {
          orientation: "horizontal",
          camera: p.value,
          controls: x.value,
          "origin-offset": Le.value,
          "cursor-world": b(ut),
          "is-cursor-visible": b(Me),
          "units-scale": b(yt),
          "dark-theme": e.darkTheme,
          class: O(e.classes?.rulerHorizontal)
        }, null, 8, ["camera", "controls", "origin-offset", "cursor-world", "is-cursor-visible", "units-scale", "dark-theme", "class"]),
        Ve(It, {
          orientation: "vertical",
          camera: p.value,
          controls: x.value,
          "origin-offset": Le.value,
          "cursor-world": b(ut),
          "is-cursor-visible": b(Me),
          "units-scale": b(yt),
          "dark-theme": e.darkTheme,
          class: O(e.classes?.rulerVertical)
        }, null, 8, ["camera", "controls", "origin-offset", "cursor-world", "is-cursor-visible", "units-scale", "dark-theme", "class"]),
        r("div", {
          class: O(["dxfk-ruler-corner", [{ "dxfk-dark": e.darkTheme }, e.classes?.rulerCorner]]),
          "aria-hidden": "true"
        }, L(b(Mn)), 3)
      ], 64)) : B("", !0),
      Te.value ? (h(), g("div", {
        key: 2,
        class: O(["dxfk-overlay-grid", { "dxfk-overlay-grid--with-rulers": e.showRulers }])
      }, [
        (h(), g(ce, null, xe(i, (w) => r("div", {
          key: w,
          class: O(["dxfk-overlay-cell", `dxfk-overlay-cell--${w}`])
        }, [
          e.fileNamePosition === w && e.showFileName && e.fileName ? (h(), g("div", {
            key: 0,
            class: O(["dxfk-file-name-overlay", e.classes?.fileNameOverlay])
          }, L(e.fileName), 3)) : B("", !0),
          e.toolbarPosition === w ? we(s.$slots, "toolbar", At({
            key: 1,
            ref_for: !0
          }, {
            resetView: qe,
            exportToPNG: Qe,
            toggleFullscreen: b(T),
            isFullscreen: b(v),
            measureMode: e.measureMode,
            toggleMeasureDistance: Ct,
            toggleMeasureArea: Mt,
            toggleMeasureAngle: Tt,
            measureDistanceActive: e.measureMode === "distance",
            measureAreaActive: e.measureMode === "area",
            measureAngleActive: e.measureMode === "angle"
          }), () => [
            Ve(ho, {
              class: O(e.classes?.toolbar),
              "show-export-button": e.showExportButton,
              "show-reset-button": e.showResetButton,
              "show-fullscreen-button": e.showFullscreenButton,
              "show-measure-button": e.showMeasureButton,
              "measure-active": e.measureMode === "distance",
              "show-measure-area-button": e.showMeasureAreaButton,
              "measure-area-active": e.measureMode === "area",
              "show-measure-angle-button": e.showMeasureAngleButton,
              "measure-angle-active": e.measureMode === "angle",
              "is-fullscreen": b(v),
              "dark-theme": e.darkTheme,
              onExport: Qe,
              onResetView: qe,
              onToggleFullscreen: b(T),
              onToggleMeasure: Ct,
              onToggleMeasureArea: Mt,
              onToggleMeasureAngle: Tt
            }, Rn({ _: 2 }, [
              s.$slots["toolbar-extra"] ? {
                name: "extra",
                fn: Vt(() => [
                  we(s.$slots, "toolbar-extra", {}, void 0, !0)
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["class", "show-export-button", "show-reset-button", "show-fullscreen-button", "show-measure-button", "measure-active", "show-measure-area-button", "measure-area-active", "show-measure-angle-button", "measure-angle-active", "is-fullscreen", "dark-theme", "onToggleFullscreen"])
          ], !0) : B("", !0),
          e.coordinatesPosition === w && (e.showCoordinates || e.showZoomLevel) ? (h(), g("div", {
            key: 2,
            class: O(["dxfk-coordinates-overlay", e.classes?.coordinatesOverlay])
          }, [
            e.showCoordinates ? (h(), g(ce, { key: 0 }, [
              r("div", wo, [
                c[6] || (c[6] = r("span", { class: "dxfk-coord-label" }, "X:", -1)),
                r("span", {
                  class: O(["dxfk-coord-value", { "dxfk-coord-value--na": !b(Me) }])
                }, L(b(Me) ? b(it).toFixed(2) : "N/A"), 3)
              ]),
              r("div", Co, [
                c[7] || (c[7] = r("span", { class: "dxfk-coord-label" }, "Y:", -1)),
                r("span", {
                  class: O(["dxfk-coord-value", { "dxfk-coord-value--na": !b(Me) }])
                }, L(b(Me) ? b(ct).toFixed(2) : "N/A"), 3)
              ])
            ], 64)) : B("", !0),
            e.showZoomLevel ? (h(), g("div", Mo, [
              r("span", To, L(b(F)) + "%", 1)
            ])) : B("", !0)
          ], 2)) : B("", !0),
          e.debugPosition === w && e.showDebugInfo ? (h(), g("div", {
            key: 3,
            class: O(["dxfk-debug-overlay", e.classes?.debugOverlay])
          }, [
            r("span", null, L(b(C).fps) + " FPS", 1),
            r("span", null, L(b(C).drawCalls) + " draws", 1),
            r("span", null, L(lt(b(C).lines)) + " lines", 1),
            r("span", null, L(lt(b(C).triangles)) + " tris", 1)
          ], 2)) : B("", !0),
          e.showLayerPanel && e.layerPanelPosition === w && b(gt).length > 0 ? (h(), Lt(bs, {
            key: 4,
            class: O(e.classes?.layerPanel),
            layers: b(gt),
            "dark-theme": e.darkTheme,
            "group-layers": e.groupLayers,
            onToggleLayer: En,
            onShowAll: An,
            onHideAll: Ln,
            onLayerHover: Yt
          }, null, 8, ["class", "layers", "dark-theme", "group-layers"])) : B("", !0),
          e.showPropertiesPanel && e.propertiesPanelPosition === w ? (h(), Lt(oo, {
            key: 5,
            class: O(e.classes?.propertiesPanel),
            event: ie.value,
            "dark-theme": e.darkTheme
          }, null, 8, ["class", "event", "dark-theme"])) : B("", !0),
          e.overlayPosition === w && s.$slots.overlay ? we(s.$slots, "overlay", At({
            key: 6,
            ref_for: !0
          }, { zoomPercent: b(F), cursorX: b(it), cursorY: b(ct) }), void 0, !0) : B("", !0)
        ], 2)), 64))
      ], 2)) : B("", !0),
      b(M) ? (h(), g("div", {
        key: 3,
        class: O(["dxfk-message-overlay dxfk-loading-overlay", e.classes?.loadingOverlay]),
        role: "status",
        "aria-live": "polite"
      }, [
        we(s.$slots, "loading", {
          phase: ue.value,
          progress: b(D)
        }, () => [
          r("div", So, [
            c[8] || (c[8] = r("div", { class: "dxfk-spinner" }, null, -1)),
            r("div", Eo, L(ue.value === "fetching" ? "Loading DXF..." : ue.value === "parsing" ? "Parsing DXF..." : "Rendering..."), 1),
            ue.value === "rendering" ? (h(), g("div", Ao, [
              r("div", {
                class: "dxfk-progress-bar",
                style: ye({ width: b(D) * 100 + "%" })
              }, null, 4)
            ])) : B("", !0),
            ue.value === "rendering" ? (h(), g("div", Lo, L(Math.round(b(D) * 100)) + "% ", 1)) : B("", !0)
          ])
        ], !0)
      ], 2)) : b(We) ? (h(), g("div", {
        key: 4,
        class: O(["dxfk-message-overlay dxfk-error-overlay", e.classes?.errorOverlay]),
        role: "alert",
        "aria-live": "assertive"
      }, [
        we(s.$slots, "error", {
          message: b(We),
          retry: Sn
        }, () => [
          r("div", $o, [
            c[9] || (c[9] = ve('<svg class="dxfk-message-icon dxfk-message-icon--error" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" data-v-d530ed4a><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" data-v-d530ed4a></path><line x1="12" y1="9" x2="12" y2="14" data-v-d530ed4a></line><circle cx="12" cy="17" r="1" fill="currentColor" stroke="none" data-v-d530ed4a></circle></svg><div class="dxfk-message-title" data-v-d530ed4a>Error</div>', 2)),
            r("div", Do, L(b(We)), 1)
          ])
        ], !0)
      ], 2)) : Te.value ? B("", !0) : (h(), g("div", {
        key: 5,
        class: O(["dxfk-message-overlay", e.classes?.emptyStateOverlay])
      }, [
        we(s.$slots, "empty-state", {}, () => [
          c[10] || (c[10] = ve('<div class="dxfk-message-content" data-v-d530ed4a><svg class="dxfk-message-icon dxfk-message-icon--placeholder" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" data-v-d530ed4a><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" data-v-d530ed4a></path><polyline points="13 2 13 9 20 9" data-v-d530ed4a></polyline></svg><div class="dxfk-message-text" data-v-d530ed4a>Select a DXF file to view</div></div>', 1))
        ], !0)
      ], 2)),
      b(Pe) ? (h(), g("div", {
        key: 6,
        class: O(["dxfk-measure-label", [{ "dxfk-dark": e.darkTheme }, e.classes?.measureLabel]]),
        style: ye({
          left: b(Pe).left + "px",
          top: b(Pe).top + "px",
          "--dxfk-measure-color": e.measureColor
        }),
        "aria-live": "polite"
      }, L(b(Pe).text), 7)) : B("", !0),
      b(Ae) ? (h(), g("div", {
        key: 7,
        class: O(["dxfk-measure-area-label", [{ "dxfk-dark": e.darkTheme }, e.classes?.measureAreaLabel]]),
        style: ye({
          left: b(Ae).left + "px",
          top: b(Ae).top + "px",
          "--dxfk-measure-color": e.measureColor
        }),
        "aria-live": "polite"
      }, [
        r("div", Fo, "Area: " + L(b(Ae).areaText), 1),
        r("div", Bo, " Perimeter: " + L(b(Ae).perimeterText), 1)
      ], 6)) : B("", !0),
      b(ze) ? (h(), g("div", {
        key: 8,
        class: O(["dxfk-measure-angle-label", [{ "dxfk-dark": e.darkTheme }, e.classes?.measureAngleLabel]]),
        style: ye({
          left: b(ze).left + "px",
          top: b(ze).top + "px",
          "--dxfk-measure-color": e.measureColor
        }),
        "aria-live": "polite"
      }, L(b(ze).text), 7)) : B("", !0),
      b(G) ? (h(), g("div", {
        key: 9,
        class: O(["dxfk-selection-rect", [
          `dxfk-selection-rect--${b(G).mode}`,
          e.classes?.selectionRect
        ]]),
        style: ye({
          left: b(G).x + "px",
          top: b(G).y + "px",
          width: b(G).width + "px",
          height: b(G).height + "px"
        }),
        "aria-hidden": "true"
      }, null, 6)) : B("", !0),
      b(dn) ? (h(), g("div", {
        key: 10,
        class: O(["dxfk-message-overlay dxfk-drop-overlay", e.classes?.dropOverlay])
      }, [...c[11] || (c[11] = [
        ve('<div class="dxfk-message-content" data-v-d530ed4a><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" data-v-d530ed4a><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" data-v-d530ed4a></path><polyline points="7 10 12 15 17 10" data-v-d530ed4a></polyline><line x1="12" y1="15" x2="12" y2="3" data-v-d530ed4a></line></svg><div class="dxfk-message-text" data-v-d530ed4a>Drop DXF file here</div></div>', 1)
      ])], 2)) : B("", !0)
    ], 42, ko));
  }
}), dr = /* @__PURE__ */ be(Po, [["__scopeId", "data-v-d530ed4a"]]), zo = { class: "dxfk-file-uploader" }, Ro = {
  for: "dxf-file-input",
  class: "dxfk-file-input-label"
}, Oo = /* @__PURE__ */ ke({
  __name: "FileUploader",
  emits: ["file-selected"],
  setup(e, { emit: t }) {
    const a = t, i = (n) => {
      const o = n.target, f = o.files?.[0];
      f && a("file-selected", f), o.value = "";
    };
    return (n, o) => (h(), g("div", zo, [
      r("label", Ro, [
        r("input", {
          id: "dxf-file-input",
          type: "file",
          accept: ".dxf",
          class: "dxfk-file-input",
          "aria-label": "Select a DXF file to load",
          onChange: i
        }, null, 32),
        o[0] || (o[0] = ve('<div class="dxfk-file-uploader-button" data-v-8597a66c><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" data-v-8597a66c><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" data-v-8597a66c></path><polyline points="17 8 12 3 7 8" data-v-8597a66c></polyline><line x1="12" y1="3" x2="12" y2="15" data-v-8597a66c></line></svg><span data-v-8597a66c>Load DXF File</span></div>', 1))
      ])
    ]));
  }
}), fr = /* @__PURE__ */ be(Oo, [["__scopeId", "data-v-8597a66c"]]), No = {
  key: 0,
  class: "dxfk-unsupported"
}, Io = { class: "dxfk-unsupported-header" }, Go = { class: "dxfk-unsupported-title" }, Uo = {
  key: 0,
  class: "dxfk-unsupported-list"
}, Vo = { class: "dxfk-unsupported-text" }, Xo = /* @__PURE__ */ ke({
  __name: "UnsupportedEntities",
  props: {
    entities: {}
  },
  setup(e) {
    const t = U(!0);
    return (a, i) => e.entities.length > 0 ? (h(), g("div", No, [
      r("div", Io, [
        i[1] || (i[1] = r("svg", {
          class: "dxfk-unsupported-icon",
          width: "20",
          height: "20",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2"
        }, [
          r("path", { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }),
          r("line", {
            x1: "12",
            y1: "9",
            x2: "12",
            y2: "14"
          }),
          r("circle", {
            cx: "12",
            cy: "17",
            r: "1",
            fill: "currentColor",
            stroke: "none"
          })
        ], -1)),
        r("span", Go, "Unsupported Elements (" + L(e.entities.length) + ")", 1),
        r("button", {
          class: "dxfk-unsupported-toggle",
          onClick: i[0] || (i[0] = (n) => t.value = !t.value)
        }, L(t.value ? "Hide" : "Show"), 1)
      ]),
      Ve(On, { name: "expand" }, {
        default: Vt(() => [
          t.value ? (h(), g("div", Uo, [
            (h(!0), g(ce, null, xe(e.entities, (n, o) => (h(), g("div", {
              key: o,
              class: "dxfk-unsupported-item"
            }, [
              i[2] || (i[2] = r("span", { class: "dxfk-unsupported-bullet" }, "•", -1)),
              r("span", Vo, L(n), 1)
            ]))), 128))
          ])) : B("", !0)
        ]),
        _: 1
      }),
      i[3] || (i[3] = r("div", { class: "dxfk-unsupported-footer" }, [
        r("span", { class: "dxfk-unsupported-note" }, " ℹ️ These elements will not be displayed on the drawing ")
      ], -1))
    ])) : B("", !0);
  }
}), vr = /* @__PURE__ */ be(Xo, [["__scopeId", "data-v-2f0beb8b"]]), Ho = { class: "dxfk-statistics" }, Wo = { class: "dxfk-statistics-grid" }, jo = { class: "dxfk-statistics-section" }, Ko = { class: "dxfk-statistics-item" }, Yo = { class: "dxfk-statistics-value" }, Zo = {
  key: 0,
  class: "dxfk-statistics-item"
}, Jo = { class: "dxfk-statistics-value" }, qo = { class: "dxfk-statistics-section" }, Qo = { class: "dxfk-statistics-item" }, _o = { class: "dxfk-statistics-value dxfk-statistics-value--highlight" }, er = { class: "dxfk-statistics-label" }, tr = { class: "dxfk-statistics-value" }, nr = { class: "dxfk-statistics-section" }, ar = { class: "dxfk-statistics-item" }, sr = { class: "dxfk-statistics-value" }, or = { class: "dxfk-statistics-item" }, rr = { class: "dxfk-statistics-value" }, lr = /* @__PURE__ */ ke({
  __name: "DXFStatistics",
  props: {
    statistics: {}
  },
  setup(e) {
    const t = e, a = (n) => n < 1024 ? `${n} B` : n < 1024 * 1024 ? `${(n / 1024).toFixed(2)} KB` : `${(n / (1024 * 1024)).toFixed(2)} MB`, i = Y(() => {
      const n = Object.entries(t.statistics.entitiesByType);
      return n.sort((o, f) => f[1] - o[1]), Object.fromEntries(n);
    });
    return (n, o) => (h(), g("div", Ho, [
      o[8] || (o[8] = r("h3", { class: "dxfk-statistics-title" }, "File Statistics", -1)),
      r("div", Wo, [
        r("div", jo, [
          o[2] || (o[2] = r("h4", { class: "dxfk-statistics-section-title" }, "General", -1)),
          r("div", Ko, [
            o[0] || (o[0] = r("span", { class: "dxfk-statistics-label" }, "File Size:", -1)),
            r("span", Yo, L(a(e.statistics.fileSize)), 1)
          ]),
          e.statistics.autocadVersion ? (h(), g("div", Zo, [
            o[1] || (o[1] = r("span", { class: "dxfk-statistics-label" }, "AutoCAD Version:", -1)),
            r("span", Jo, L(e.statistics.autocadVersion), 1)
          ])) : B("", !0)
        ]),
        r("div", qo, [
          o[4] || (o[4] = r("h4", { class: "dxfk-statistics-section-title" }, "Entities", -1)),
          r("div", Qo, [
            o[3] || (o[3] = r("span", { class: "dxfk-statistics-label" }, "Total Entities:", -1)),
            r("span", _o, L(e.statistics.totalEntities), 1)
          ]),
          (h(!0), g(ce, null, xe(i.value, (f, v) => (h(), g("div", {
            key: v,
            class: "dxfk-statistics-item dxfk-statistics-item--entity-type"
          }, [
            r("span", er, L(v) + ":", 1),
            r("span", tr, L(f), 1)
          ]))), 128))
        ]),
        r("div", nr, [
          o[7] || (o[7] = r("h4", { class: "dxfk-statistics-section-title" }, "Structure", -1)),
          r("div", ar, [
            o[5] || (o[5] = r("span", { class: "dxfk-statistics-label" }, "Layers:", -1)),
            r("span", sr, L(e.statistics.layersCount), 1)
          ]),
          r("div", or, [
            o[6] || (o[6] = r("span", { class: "dxfk-statistics-label" }, "Blocks:", -1)),
            r("span", rr, L(e.statistics.blocksCount), 1)
          ])
        ])
      ])
    ]));
  }
}), hr = /* @__PURE__ */ be(lr, [["__scopeId", "data-v-453cc967"]]);
export {
  hr as DXFStatistics,
  dr as DXFViewer,
  fr as FileUploader,
  bs as LayerPanel,
  oo as PropertiesPanel,
  vr as UnsupportedEntities,
  ho as ViewerToolbar,
  yr as buildWorldRect,
  xr as formatAngleValue,
  kr as formatAreaValue,
  br as formatMeasureValue,
  js as getEntityProperties,
  wr as normaliseScreenRect,
  Cr as resolveSelectionMode,
  Aa as useAngleMeasurement,
  Sa as useAreaMeasurement,
  pa as useDXFRenderer,
  ba as useHighlight,
  ya as useLayers,
  Ma as useMeasurement,
  ka as usePicking,
  wa as useRectangleSelection,
  La as useSnap,
  ga as useThreeScene
};
